(function() {
  var DURATION_GUIDANCE = {
    'mild|easy':         {before: '½ sachet in 250 ml water', during: '½ sachet per hour',     after: '1 sachet in 500 ml water'},
    'mild|moderate':     {before: '½ sachet in 250 ml water', during: '½–1 sachet per hour',   after: '1 sachet in 500 ml water'},
    'mild|hard':         {before: '½ sachet in 250 ml water', during: '1 sachet per hour',      after: '1 sachet in 500 ml water'},
    'moderate|easy':     {before: '½ sachet in 250 ml water', during: '1–1½ sachets per hour', after: '1 sachet in 500 ml water'},
    'moderate|moderate': {before: '½ sachet in 250 ml water', during: '1½–2 sachets per hour', after: '1 sachet in 500 ml water'},
    'moderate|hard':     {before: '½ sachet in 250 ml water', during: '2–2½ sachets per hour', after: '1 sachet in 500 ml water'},
    'heavy|easy':        {before: '½ sachet in 250 ml water', during: '2½–3 sachets per hour', after: '1 sachet in 500 ml water'},
    'heavy|moderate':    {before: '½ sachet in 250 ml water', during: '3 sachets per hour',     after: '1 sachet in 500 ml water'},
    'heavy|hard':        {before: '½ sachet in 250 ml water', during: '3–3½ sachets per hour', after: '1 sachet in 500 ml water'},
  };

  var HYDRATION_DATA = {
    // ── MILD ──────────────────────────────────────────────────────────────────
    // < 1 hr
    'mild|lt1|cold|easy':         {total: '1',   note: 'Your sodium stores are sufficient for this effort. Consuming just plain water before this session is enough.', packRecommendation: 'A Pack of 10 covers 10 sessions like this.', why: ''},
    'mild|lt1|cold|moderate':     {total: '1',   note: 'Short + cold = low loss. Post-session sufficient.', packRecommendation: 'A Pack of 10 covers 10 sessions like this.', why: ''},
    'mild|lt1|cold|hard':         {total: '1-2', note: 'Hard effort elevates loss even in cold.', packRecommendation: 'A Pack of 10 covers 5 sessions like this.', why: ''},
    'mild|lt1|moderate|easy':     {total: '1',   note: 'Low demand session. Post-session covers recovery.', packRecommendation: 'A Pack of 10 covers 10 sessions like this.', why: ''},
    'mild|lt1|moderate|moderate': {total: '1-2', note: 'Add pre-session on warmer days.', packRecommendation: 'A Pack of 10 covers 5 sessions like this.', why: ''},
    'mild|lt1|moderate|hard':     {total: '2',   note: 'Hard effort bumps up sodium need noticeably.', packRecommendation: 'A Pack of 10 covers 5 sessions like this.', why: ''},
    'mild|lt1|hot|easy':          {total: '2',   note: 'Heat matters even for mild sweaters. Don\'t skip pre-session.', packRecommendation: 'A Pack of 10 covers 5 sessions like this.', why: ''},
    'mild|lt1|hot|moderate':      {total: '2',   note: 'Hot + moderate = borderline moderate tier.', packRecommendation: 'A Pack of 10 covers 5 sessions like this.', why: ''},
    'mild|lt1|hot|hard':          {total: '3',   note: 'Hot + hard even under 1 hr = full during.', packRecommendation: 'A Pack of 10 covers 3 sessions like this.', why: ''},

    // 1–2 hr
    'mild|1to2|cold|easy':         {total: '2', note: 'Longer duration means replenishment needed mid-session.', packRecommendation: 'A Pack of 10 covers 5 sessions like this.', why: ''},
    'mild|1to2|cold|moderate':     {total: '2', note: 'Cold limits loss but duration makes it necessary.', packRecommendation: 'A Pack of 10 covers 5 sessions like this.', why: ''},
    'mild|1to2|cold|hard':         {total: '2', note: 'Hard intensity compensates for cold weather.', packRecommendation: 'A Pack of 10 covers 5 sessions like this.', why: ''},
    'mild|1to2|moderate|easy':     {total: '2', note: 'Spread intake evenly. No need to rush.', packRecommendation: 'A Pack of 10 covers 5 sessions like this.', why: ''},
    'mild|1to2|moderate|moderate': {total: '2', note: 'Standard mild protocol covers this well.', packRecommendation: 'A Pack of 10 covers 5 sessions like this.', why: ''},
    'mild|1to2|moderate|hard':     {total: '3', note: 'Pushes toward moderate tier. Stay consistent with sipping.', packRecommendation: 'A Pack of 10 covers 3 sessions like this.', why: ''},
    'mild|1to2|hot|easy':          {total: '3', note: 'Heat makes duration feel longer on your electrolytes.', packRecommendation: 'A Pack of 10 covers 3 sessions like this.', why: ''},
    'mild|1to2|hot|moderate':      {total: '3', note: 'At the upper edge of mild. Treat like moderate.', packRecommendation: 'A Pack of 10 covers 3 sessions like this.', why: ''},
    'mild|1to2|hot|hard':          {total: '3', note: 'Hot + hard + 1.5 hrs — follow moderate protocol.', packRecommendation: 'A Pack of 10 covers 3 sessions like this.', why: ''},

    // 2–3 hr
    'mild|2to3|cold|easy':         {total: '2', note: 'Long but low-loss. Consistent small sips.', packRecommendation: 'A Pack of 10 covers 5 sessions like this.', why: ''},
    'mild|2to3|cold|moderate':     {total: '3', note: 'Cold conditions keep loss manageable over long runs.', packRecommendation: 'A Pack of 10 covers 3 sessions like this.', why: ''},
    'mild|2to3|cold|hard':         {total: '3', note: 'Hard intensity over long durations — don\'t skip mid-run sachets.', packRecommendation: 'A Pack of 10 covers 3 sessions like this.', why: ''},
    'mild|2to3|moderate|easy':     {total: '3', note: 'Duration is the primary driver here.', packRecommendation: 'A Pack of 10 covers 3 sessions like this.', why: ''},
    'mild|2to3|moderate|moderate': {total: '3', note: 'Every 60 min mid-session keeps levels stable.', packRecommendation: 'A Pack of 10 covers 3 sessions like this.', why: ''},
    'mild|2to3|moderate|hard':     {total: '4', note: 'Treat as moderate sweater at this combination.', packRecommendation: 'A Pack of 30 covers 7 sessions like this.', why: ''},
    'mild|2to3|hot|easy':          {total: '3', note: 'Hot + long = consistent replenishment non-negotiable.', packRecommendation: 'A Pack of 10 covers 3 sessions like this.', why: ''},
    'mild|2to3|hot|moderate':      {total: '4', note: 'Upper mild boundary. Follow moderate protocol.', packRecommendation: 'A Pack of 30 covers 7 sessions like this.', why: ''},
    'mild|2to3|hot|hard':          {total: '5', note: 'This scenario crosses into moderate regardless of sweat type.', packRecommendation: 'A Pack of 30 covers 6 sessions like this.', why: ''},

    // 3+ hr
    'mild|3plus|cold|easy':         {total: '4', note: 'Pre-load the night before for ultra-long sessions.', packRecommendation: 'A Pack of 30 covers 7 sessions like this.', why: ''},
    'mild|3plus|cold|moderate':     {total: '5', note: 'Duration dominates here. Stick to hourly sachets.', packRecommendation: 'A Pack of 30 covers 6 sessions like this.', why: ''},
    'mild|3plus|cold|hard':         {total: '6', note: 'Hard + 3 hrs crosses into moderate territory regardless.', packRecommendation: 'A Pack of 30 covers 5 sessions like this.', why: ''},
    'mild|3plus|moderate|easy':     {total: '5', note: 'Even easy long runs need hourly electrolytes.', packRecommendation: 'A Pack of 30 covers 6 sessions like this.', why: ''},
    'mild|3plus|moderate|moderate': {total: '6', note: 'Follow moderate sweater protocol for this combination.', packRecommendation: 'A Pack of 30 covers 5 sessions like this.', why: ''},
    'mild|3plus|moderate|hard':     {total: '7', note: 'Hard 3+ hr effort — use moderate/heavy protocol.', packRecommendation: 'A Pack of 30 covers 4 sessions like this.', why: ''},
    'mild|3plus|hot|easy':          {total: '6', note: 'Hot weather over 3 hrs — pre-load is essential.', packRecommendation: 'A Pack of 30 covers 5 sessions like this.', why: ''},
    'mild|3plus|hot|moderate':      {total: '7', note: 'Treat as heavy sweater for this scenario.', packRecommendation: 'A Pack of 30 covers 4 sessions like this.', why: ''},
    'mild|3plus|hot|hard':          {total: '8', note: 'Max demand scenario even for mild sweaters. Full heavy protocol.', packRecommendation: 'A Pack of 30 covers 3 sessions like this.', why: ''},

    // ── MODERATE ──────────────────────────────────────────────────────────────
    // < 1 hr
    'moderate|lt1|cold|easy':         {total: '2',   note: 'Even short cold sessions need a pre-session for moderate sweaters.', packRecommendation: '2 sachets needed. A Pack of 10 covers 5 sessions like this.', why: ''},
    'moderate|lt1|cold|moderate':     {total: '2-3', note: 'Moderate intensity raises loss even in cold.', packRecommendation: '3 sachets needed. A Pack of 10 covers 3 sessions like this.', why: ''},
    'moderate|lt1|cold|hard':         {total: '3',   note: 'Hard effort under 1 hr still needs full during-session sachet.', packRecommendation: '3 sachets needed. A Pack of 10 covers 3 sessions like this.', why: ''},
    'moderate|lt1|moderate|easy':     {total: '2',   note: 'Pre + post covers this scenario adequately.', packRecommendation: '2 sachets needed. A Pack of 10 covers 5 sessions like this.', why: ''},
    'moderate|lt1|moderate|moderate': {total: '3',   note: 'Follow hydration protocol for this scenario.', packRecommendation: '3 sachets needed. A Pack of 10 covers 3 sessions like this.', why: ''},
    'moderate|lt1|moderate|hard':     {total: '3',   note: 'Follow hydration protocol for this scenario.', packRecommendation: '3 sachets needed. A Pack of 10 covers 3 sessions like this.', why: ''},
    'moderate|lt1|hot|easy':          {total: '3',   note: 'Follow hydration protocol for this scenario.', packRecommendation: '3 sachets needed. A Pack of 10 covers 3 sessions like this.', why: ''},
    'moderate|lt1|hot|moderate':      {total: '3-4', note: 'Follow hydration protocol for this scenario.', packRecommendation: '4 sachets needed. A Pack of 30 covers 7 sessions like this.', why: ''},
    'moderate|lt1|hot|hard':          {total: '4',   note: 'Follow hydration protocol for this scenario.', packRecommendation: '4 sachets needed. A Pack of 30 covers 7 sessions like this.', why: ''},

    // 1–2 hr
    'moderate|1to2|cold|easy':         {total: '2',   note: 'Long but low-loss. Consistent small sips.', packRecommendation: '2 sachets needed. A Pack of 10 covers 5 sessions like this.', why: ''},
    'moderate|1to2|cold|moderate':     {total: '2-3', note: 'Cold conditions keep loss manageable over long runs.', packRecommendation: '3 sachets needed. A Pack of 10 covers 3 sessions like this.', why: ''},
    'moderate|1to2|cold|hard':         {total: '3',   note: 'Hard intensity over long durations — don\'t skip mid-run sachets.', packRecommendation: '3 sachets needed. A Pack of 10 covers 3 sessions like this.', why: ''},
    'moderate|1to2|moderate|easy':     {total: '2-3', note: 'Duration is the primary driver here.', packRecommendation: '3 sachets needed. A Pack of 10 covers 3 sessions like this.', why: ''},
    'moderate|1to2|moderate|moderate': {total: '3',   note: 'Every 60 min mid-session keeps levels stable.', packRecommendation: '3 sachets needed. A Pack of 10 covers 3 sessions like this.', why: ''},
    'moderate|1to2|moderate|hard':     {total: '3-4', note: 'Treat as moderate sweater at this combination.', packRecommendation: '4 sachets needed. A Pack of 30 covers 7 sessions like this.', why: ''},
    'moderate|1to2|hot|easy':          {total: '3',   note: 'Hot + long = consistent replenishment non-negotiable.', packRecommendation: '3 sachets needed. A Pack of 10 covers 3 sessions like this.', why: ''},
    'moderate|1to2|hot|moderate':      {total: '3-4', note: 'Upper mild boundary. Follow moderate protocol.', packRecommendation: '4 sachets needed. A Pack of 30 covers 7 sessions like this.', why: ''},
    'moderate|1to2|hot|hard':          {total: '4-5', note: 'This scenario crosses into moderate regardless of sweat type.', packRecommendation: '5 sachets needed. A Pack of 30 covers 6 sessions like this.', why: ''},

    // 2–3 hr
    'moderate|2to3|cold|easy':         {total: '3-4', note: 'Pre-load the night before for ultra-long sessions.', packRecommendation: '4 sachets needed. A Pack of 30 covers 7 sessions like this.', why: ''},
    'moderate|2to3|cold|moderate':     {total: '4-5', note: 'Duration dominates here. Stick to hourly sachets.', packRecommendation: '5 sachets needed. A Pack of 30 covers 6 sessions like this.', why: ''},
    'moderate|2to3|cold|hard':         {total: '5-6', note: 'Hard + 3 hrs crosses into moderate territory regardless.', packRecommendation: '6 sachets needed. A Pack of 30 covers 5 sessions like this.', why: ''},
    'moderate|2to3|moderate|easy':     {total: '4-5', note: 'Even easy long runs need hourly electrolytes.', packRecommendation: '5 sachets needed. A Pack of 30 covers 6 sessions like this.', why: ''},
    'moderate|2to3|moderate|moderate': {total: '5-6', note: 'Follow moderate sweater protocol for this combination.', packRecommendation: '6 sachets needed. A Pack of 30 covers 5 sessions like this.', why: ''},
    'moderate|2to3|moderate|hard':     {total: '6-7', note: 'Hard 3+ hr effort — use moderate/heavy protocol.', packRecommendation: '7 sachets needed. A Pack of 30 covers 4 sessions like this.', why: ''},
    'moderate|2to3|hot|easy':          {total: '5-6', note: 'Hot weather over 3 hrs — pre-load is essential.', packRecommendation: '6 sachets needed. A Pack of 30 covers 5 sessions like this.', why: ''},
    'moderate|2to3|hot|moderate':      {total: '6-7', note: 'Treat as heavy sweater for this scenario.', packRecommendation: '7 sachets needed. A Pack of 30 covers 4 sessions like this.', why: ''},
    'moderate|2to3|hot|hard':          {total: '7+', note: 'Max demand scenario even for mild sweaters. Full heavy protocol.', packRecommendation: '8 sachets needed. A Pack of 30 covers 3 sessions like this.', why: ''},

    // 3+ hr
    'moderate|3plus|cold|easy':         {total: '4-5', note: 'Follow hydration protocol for this scenario.', packRecommendation: '5 sachets needed. A Pack of 30 covers 6 sessions like this.', why: ''},
    'moderate|3plus|cold|moderate':     {total: '5-6', note: 'Follow hydration protocol for this scenario.', packRecommendation: '6 sachets needed. A Pack of 30 covers 5 sessions like this.', why: ''},
    'moderate|3plus|cold|hard':         {total: '6',   note: 'Follow hydration protocol for this scenario.', packRecommendation: '6 sachets needed. A Pack of 30 covers 5 sessions like this.', why: ''},
    'moderate|3plus|moderate|easy':     {total: '—',   note: 'Follow hydration protocol for this scenario.', packRecommendation: '6 sachets needed. A Pack of 30 covers 5 sessions like this.', why: ''},
    'moderate|3plus|moderate|moderate': {total: '6-7', note: 'Follow hydration protocol for this scenario.', packRecommendation: '7 sachets needed. A Pack of 30 covers 4 sessions like this.', why: ''},
    'moderate|3plus|moderate|hard':     {total: '6-7', note: 'Follow hydration protocol for this scenario.', packRecommendation: '7 sachets needed. A Pack of 30 covers 4 sessions like this.', why: ''},
    'moderate|3plus|hot|easy':          {total: '6-7', note: 'Follow hydration protocol for this scenario.', packRecommendation: '7 sachets needed. A Pack of 30 covers 4 sessions like this.', why: ''},
    'moderate|3plus|hot|moderate':      {total: '7-8', note: 'Follow hydration protocol for this scenario.', packRecommendation: '8 sachets needed. A Pack of 30 covers 3 sessions like this.', why: ''},
    'moderate|3plus|hot|hard':          {total: '8+', note: 'Follow hydration protocol for this scenario.', packRecommendation: '9 sachets needed. A Pack of 30 covers 3 sessions like this.', why: ''},

    // ── HEAVY ─────────────────────────────────────────────────────────────────
    // < 1 hr
    'heavy|lt1|cold|easy':         {total: '3',   note: 'Follow hydration protocol for this scenario.', packRecommendation: '3 sachets needed. A Pack of 10 covers 3 sessions like this.', why: ''},
    'heavy|lt1|cold|moderate':     {total: '2-3', note: 'Follow hydration protocol for this scenario.', packRecommendation: '3 sachets needed. A Pack of 10 covers 3 sessions like this.', why: ''},
    'heavy|lt1|cold|hard':         {total: '4',   note: 'Follow hydration protocol for this scenario.', packRecommendation: '4 sachets needed. A Pack of 30 covers 7 sessions like this.', why: ''},
    'heavy|lt1|moderate|easy':     {total: '2',   note: 'Follow hydration protocol for this scenario.', packRecommendation: '2 sachets needed. A Pack of 10 covers 5 sessions like this.', why: ''},
    'heavy|lt1|moderate|moderate': {total: '4',   note: 'Follow hydration protocol for this scenario.', packRecommendation: '4 sachets needed. A Pack of 30 covers 7 sessions like this.', why: ''},
    'heavy|lt1|moderate|hard':     {total: '3',   note: 'Follow hydration protocol for this scenario.', packRecommendation: '3 sachets needed. A Pack of 10 covers 3 sessions like this.', why: ''},
    'heavy|lt1|hot|easy':          {total: '4-5', note: 'Follow hydration protocol for this scenario.', packRecommendation: '5 sachets needed. A Pack of 30 covers 6 sessions like this.', why: ''},
    'heavy|lt1|hot|moderate':      {total: '3-4', note: 'Follow hydration protocol for this scenario.', packRecommendation: '4 sachets needed. A Pack of 30 covers 7 sessions like this.', why: ''},
    'heavy|lt1|hot|hard':          {total: '4-5', note: 'Follow hydration protocol for this scenario.', packRecommendation: '5 sachets needed. A Pack of 30 covers 6 sessions like this.', why: ''},

    // 1–2 hr
    'heavy|1to2|cold|easy':         {total: '2',   note: 'Follow hydration protocol for this scenario.', packRecommendation: '2 sachets needed. A Pack of 10 covers 5 sessions like this.', why: ''},
    'heavy|1to2|cold|moderate':     {total: '2-3', note: 'Follow hydration protocol for this scenario.', packRecommendation: '3 sachets needed. A Pack of 10 covers 3 sessions like this.', why: ''},
    'heavy|1to2|cold|hard':         {total: '3',   note: 'Follow hydration protocol for this scenario.', packRecommendation: '3 sachets needed. A Pack of 10 covers 3 sessions like this.', why: ''},
    'heavy|1to2|moderate|easy':     {total: '2-3', note: 'Follow hydration protocol for this scenario.', packRecommendation: '3 sachets needed. A Pack of 10 covers 3 sessions like this.', why: ''},
    'heavy|1to2|moderate|moderate': {total: '3',   note: 'Follow hydration protocol for this scenario.', packRecommendation: '3 sachets needed. A Pack of 10 covers 3 sessions like this.', why: ''},
    'heavy|1to2|moderate|hard':     {total: '3-4', note: 'Follow hydration protocol for this scenario.', packRecommendation: '4 sachets needed. A Pack of 30 covers 7 sessions like this.', why: ''},
    'heavy|1to2|hot|easy':          {total: '3',   note: 'Follow hydration protocol for this scenario.', packRecommendation: '3 sachets needed. A Pack of 10 covers 3 sessions like this.', why: ''},
    'heavy|1to2|hot|moderate':      {total: '3-4', note: 'Follow hydration protocol for this scenario.', packRecommendation: '4 sachets needed. A Pack of 30 covers 7 sessions like this.', why: ''},
    'heavy|1to2|hot|hard':          {total: '4-5', note: 'Follow hydration protocol for this scenario.', packRecommendation: '5 sachets needed. A Pack of 30 covers 6 sessions like this.', why: ''},

    // 2–3 hr
    'heavy|2to3|cold|easy':         {total: '4',   note: 'Follow hydration protocol for this scenario.', packRecommendation: '4 sachets needed. A Pack of 30 covers 7 sessions like this.', why: ''},
    'heavy|2to3|cold|moderate':     {total: '4-5', note: 'Follow hydration protocol for this scenario.', packRecommendation: '5 sachets needed. A Pack of 30 covers 6 sessions like this.', why: ''},
    'heavy|2to3|cold|hard':         {total: '6',   note: 'Follow hydration protocol for this scenario.', packRecommendation: '6 sachets needed. A Pack of 30 covers 5 sessions like this.', why: ''},
    'heavy|2to3|moderate|easy':     {total: '6',   note: 'Follow hydration protocol for this scenario.', packRecommendation: '6 sachets needed. A Pack of 30 covers 5 sessions like this.', why: ''},
    'heavy|2to3|moderate|moderate': {total: '5-6', note: 'Follow hydration protocol for this scenario.', packRecommendation: '6 sachets needed. A Pack of 30 covers 5 sessions like this.', why: ''},
    'heavy|2to3|moderate|hard':     {total: '7',   note: 'Follow hydration protocol for this scenario.', packRecommendation: '7 sachets needed. A Pack of 30 covers 4 sessions like this.', why: ''},
    'heavy|2to3|hot|easy':          {total: '6',   note: 'Follow hydration protocol for this scenario.', packRecommendation: '6 sachets needed. A Pack of 30 covers 5 sessions like this.', why: ''},
    'heavy|2to3|hot|moderate':      {total: '6-7', note: 'Follow hydration protocol for this scenario.', packRecommendation: '7 sachets needed. A Pack of 30 covers 4 sessions like this.', why: ''},
    'heavy|2to3|hot|hard':          {total: '7+', note: 'Follow hydration protocol for this scenario.', packRecommendation: '8 sachets needed. A Pack of 30 covers 3 sessions like this.', why: ''},

    // 3+ hr
    'heavy|3plus|cold|easy':         {total: '4-5', note: 'Follow hydration protocol for this scenario.', packRecommendation: '5 sachets needed. A Pack of 30 covers 6 sessions like this.', why: ''},
    'heavy|3plus|cold|moderate':     {total: '5-6', note: 'Follow hydration protocol for this scenario.', packRecommendation: '6 sachets needed. A Pack of 30 covers 5 sessions like this.', why: ''},
    'heavy|3plus|cold|hard':         {total: '6',   note: 'Follow hydration protocol for this scenario.', packRecommendation: '6 sachets needed. A Pack of 30 covers 5 sessions like this.', why: ''},
    'heavy|3plus|moderate|easy':     {total: '—',   note: 'Follow hydration protocol for this scenario.', packRecommendation: '6 sachets needed. A Pack of 30 covers 5 sessions like this.', why: ''},
    'heavy|3plus|moderate|moderate': {total: '6-7', note: 'Follow hydration protocol for this scenario.', packRecommendation: '7 sachets needed. A Pack of 30 covers 4 sessions like this.', why: ''},
    'heavy|3plus|moderate|hard':     {total: '6-7', note: 'Follow hydration protocol for this scenario.', packRecommendation: '7 sachets needed. A Pack of 30 covers 4 sessions like this.', why: ''},
    'heavy|3plus|hot|easy':          {total: '6-7', note: 'Follow hydration protocol for this scenario.', packRecommendation: '7 sachets needed. A Pack of 30 covers 4 sessions like this.', why: ''},
    'heavy|3plus|hot|moderate':      {total: '7-8', note: 'Follow hydration protocol for this scenario.', packRecommendation: '8 sachets needed. A Pack of 30 covers 3 sessions like this.', why: ''},
    'heavy|3plus|hot|hard':          {total: '8+', note: 'Follow hydration protocol for this scenario.', packRecommendation: '9 sachets needed. A Pack of 30 covers 3 sessions like this.', why: ''},
  };

  function parseTotal(str) {
    if (!str || str === '—' || str === '-') return null;
    var match = str.match(/\d+/);
    return match ? parseInt(match[0], 10) : null;
  }

  // Returns the pack sessions sentence from packRecommendation, stripping the leading sachet count.
  function getPackSubtitle(packRecommendation) {
    if (!packRecommendation) return '';
    var dotIdx = packRecommendation.indexOf('. ');
    return dotIdx !== -1 ? packRecommendation.slice(dotIdx + 2) : packRecommendation;
  }

  function getFlavors(qty) {
    var guava = Math.ceil(qty / 2);
    var lime  = qty - guava;
    return { guava: guava, lime: lime };
  }

  function flavorLabel(qty) {
    var f = getFlavors(qty);
    if (f.lime === 0) return f.guava + ' Guava';
    return f.guava + ' Guava + ' + f.lime + ' Lime';
  }

  function formatPrice(total) {
    return '₹ ' + (total).toLocaleString('en-IN');
  }

  function initCalculator(sid) {
    var wizard     = document.getElementById('hc-wizard-'      + sid);
    var results    = document.getElementById('hc-results-'     + sid);
    var prompt     = document.getElementById('hc-prompt-'      + sid);
    var promptText = document.getElementById('hc-prompt-text-' + sid);
    if (!wizard || !results || !prompt) return;

    var els = {
      sodiumBadge: document.getElementById('hc-sodium-badge-' + sid),
      sodium:      document.getElementById('hc-sodium-'       + sid),
      water:       document.getElementById('hc-water-'        + sid),
      before:      document.getElementById('hc-before-'       + sid),
      during:      document.getElementById('hc-during-'       + sid),
      after:       document.getElementById('hc-after-'        + sid),
      beforeNote:    document.getElementById('hc-before-note-'      + sid),
      duringNote:    document.getElementById('hc-during-note-'      + sid),
      afterNote:     document.getElementById('hc-after-note-'       + sid),
      beforeWhyWrap: document.getElementById('hc-before-why-wrap-'  + sid),
      duringWhyWrap: document.getElementById('hc-during-why-wrap-'  + sid),
      afterWhyWrap:  document.getElementById('hc-after-why-wrap-'   + sid),
      note:        document.getElementById('hc-note-'         + sid),
      greeting:    document.getElementById('hc-results-greeting-' + sid),
      sumDuration: document.getElementById('hc-sum-duration-' + sid),
      sumIntensity:document.getElementById('hc-sum-intensity-'+ sid),
      sumSweat:    document.getElementById('hc-sum-sweat-'    + sid),
      sumLocation: document.getElementById('hc-sum-location-' + sid),
      total:       document.getElementById('hc-total-'        + sid),
      recHeaderTitle: document.getElementById('hc-rec-header-title-' + sid),
      recHeaderSub:   document.getElementById('hc-rec-header-sub-'   + sid),
    };

    // Why-tooltip click toggle (for touch devices)
    results.addEventListener('click', function(e) {
      var btn = e.target.closest ? e.target.closest('.hc-why-btn') : null;
      if (btn) {
        var wrap = btn.parentElement;
        var isOpen = wrap.classList.contains('is-open');
        results.querySelectorAll('.hc-why-wrap.is-open').forEach(function(w) { w.classList.remove('is-open'); });
        if (!isOpen) wrap.classList.add('is-open');
        e.stopPropagation();
        return;
      }
      results.querySelectorAll('.hc-why-wrap.is-open').forEach(function(w) { w.classList.remove('is-open'); });

    });

    // Info icon tap toggle (for touch devices); close when tapping outside
    var statsInfoWrap = document.getElementById('hc-stats-info-wrap-' + sid);
    if (statsInfoWrap) {
      statsInfoWrap.addEventListener('click', function(e) {
        e.stopPropagation();
        statsInfoWrap.classList.toggle('is-open');
      });
      document.addEventListener('click', function() {
        statsInfoWrap.classList.remove('is-open');
      });
    }

    var state = { sweat: null, duration: null, weather: null, intensity: 'easy', city: null, temp: null, humidity: null, name: null };
    var stepPanels = Array.prototype.slice.call(wizard.querySelectorAll('.hc-step[data-step-index]'));
    var totalSteps = stepPanels.length || parseInt(wizard.dataset.totalSteps || '4', 10);
    var currentStep = 1;
    var stepProgress = document.getElementById('hc-step-progress-current-' + sid);
    var weatherApiKey = wizard.dataset.weatherApi || '';
    var gmapsApiKey   = wizard.dataset.gmapsApi || '';

    // Google Maps Places — initialized when Maps JS API loads
    var gmapsReady = false;

    function initGmapsServices() {
      if (google.maps.places && google.maps.places.AutocompleteSuggestion) {
        gmapsReady = true;
      }
    }

    document.addEventListener('hc:mapsready', function() {
      initGmapsServices();
    });

    // Handle race condition: Maps API already loaded from cache before this script ran
    if (window.google && window.google.maps && window.google.maps.places) {
      initGmapsServices();
    } else if (gmapsApiKey && !document.querySelector('script[src*="maps.googleapis.com"]')) {
      window.initHCMaps = function() {
        document.dispatchEvent(new Event('hc:mapsready'));
      };
      var mapsScript = document.createElement('script');
      mapsScript.src = 'https://maps.googleapis.com/maps/api/js?key=' + encodeURIComponent(gmapsApiKey) + '&libraries=places&callback=initHCMaps';
      mapsScript.async = true;
      document.head.appendChild(mapsScript);
    }

    var cityGrid = document.getElementById('hc-city-grid-' + sid);
    var weatherSelect = document.getElementById('hc-step-weather-select-' + sid);
    var weatherConfirm = document.getElementById('hc-step-weather-confirm-' + sid);
    var detectBtn = document.getElementById('hc-detect-weather-' + sid);
    var weatherBackBtn = document.getElementById('hc-weather-back-' + sid);
    var weatherProceedBtn = document.getElementById('hc-weather-proceed-' + sid);

    var weatherCityEl = document.getElementById('hc-weather-city-' + sid);
    var weatherTempEl = document.getElementById('hc-weather-temp-' + sid);
    var weatherHumEl = document.getElementById('hc-weather-humidity-' + sid);
    var weatherCondEl = document.getElementById('hc-weather-condition-' + sid);
    var weatherConfirmTitle = document.getElementById('hc-weather-confirm-title-' + sid);
    var weatherConfirmCopy = document.getElementById('hc-weather-confirm-copy-' + sid);
    var inlineError = document.getElementById('hc-inline-error-' + sid);

    var intensityProceedBtn = document.getElementById('hc-intensity-proceed-' + sid);
    var intensityBackBtn = document.getElementById('hc-intensity-back-' + sid);
    var intensityScale = wizard.querySelector('.hc-intensity-scale');
    var intensitySlider = document.getElementById('hc-intensity-slider-' + sid);
    var intensityCurve = document.getElementById('hc-intensity-curve-' + sid);
    var intensityKnob = document.getElementById('hc-intensity-knob-' + sid);
    var intensityNote = wizard.querySelector('.hc-intensity-note');
    var sweatBackBtn = document.getElementById('hc-sweat-back-' + sid);
    var resultsProceedBtn = document.getElementById('hc-results-proceed-' + sid);
    var recalcBtn = document.getElementById('hc-recalculate-' + sid);
    var summaryEl = document.getElementById('hc-results-summary-' + sid);


    function clearInlineError() {
      if (!inlineError) return;
      inlineError.hidden = true;
      inlineError.textContent = '';
    }

    function setInlineError(msg) {
      if (!inlineError) return;
      inlineError.hidden = false;
      inlineError.textContent = msg;
    }

    function weatherBucket(temp) {
      if (temp < 15) return 'cold';
      if (temp <= 25) return 'moderate';
      return 'hot';
    }

    function getIntensityFromSlider(value) {
      if (value < 33) return 'easy';
      if (value < 66) return 'moderate';
      return 'hard';
    }

    function clamp(value, min, max) {
      return Math.max(min, Math.min(max, value));
    }

    function getCurveYPercent(percent) {
      // Maps slider value to Y% matching the SVG curve: y=128 at x=0, y=8 at x=560, viewBox height=170
      // Start: 128/170 = 75.3%, End: 8/170 = 4.7%, range = 70.6 pts
      return 75.3 - 70.6 * Math.pow(percent / 100, 1.6);
    }

    function updateIntensityGradient(mode) {
      var gradient = document.getElementById('hc-intensity-gradient-' + sid);
      if (!gradient) return;

      var stops = gradient.querySelectorAll('stop');
      if (!stops || stops.length < 5) return;

      var fadedStops = [
        { color: '#1aaa94', opacity: '1' },
        { color: '#c8d640', opacity: '0.95' },
        { color: '#f5d742', opacity: '0.72' },
        { color: '#f7e58a', opacity: '0.3' },
        { color: '#fff9e6', opacity: '0.08' }
      ];

      var solidStops = [
        { color: '#1aaa94', opacity: '1' },
        { color: '#c8d640', opacity: '1' },
        { color: '#f5b942', opacity: '1' },
        { color: '#ff9b52', opacity: '1' },
        { color: '#f96b71', opacity: '1' }
      ];

      var activeStops = mode === 'hard' ? solidStops : fadedStops;
      stops.forEach(function(stop, index) {
        stop.setAttribute('stop-color', activeStops[index].color);
        stop.setAttribute('stop-opacity', activeStops[index].opacity);
      });
    }

    function applyIntensityUI() {
      if (!intensitySlider || !intensityScale) return;
      var sliderValue = parseInt(intensitySlider.value, 10);
      state.intensity = getIntensityFromSlider(sliderValue);

      intensityScale.classList.remove('is-easy', 'is-moderate', 'is-hard');
      intensityScale.classList.add('is-' + state.intensity);
      updateIntensityGradient(state.intensity);

      if (intensityKnob && intensityCurve) {
        var rect = intensityCurve.getBoundingClientRect();
        var x = (sliderValue / 100) * rect.width;
        var y = (getCurveYPercent(sliderValue) / 100) * rect.height;
        intensityKnob.style.left = x + 'px';
        intensityKnob.style.top = y + 'px';
        intensityKnob.setAttribute('aria-valuenow', String(sliderValue));

        var maskRect = document.getElementById('hc-intensity-mask-rect-' + sid);
        if (maskRect) {
          maskRect.setAttribute('width', sliderValue + '%');
        }
      }

      if (intensityNote) {
        var notes = {
          easy: 'You can run and speak in full sentences without losing breath',
          moderate: 'Breathing is harder \u2014 you can speak but only in short phrases',
          hard: 'Maximum effort \u2014 you can barely speak at this exertion level'
        };
        intensityNote.textContent = notes[state.intensity] || notes.easy;
      }
    }

    function updateIntensityFromClientX(clientX) {
      if (!intensityCurve || !intensitySlider) return;
      var rect = intensityCurve.getBoundingClientRect();
      var percent = clamp(((clientX - rect.left) / rect.width) * 100, 0, 100);
      intensitySlider.value = String(Math.round(percent));
      applyIntensityUI();
    }

    function getWeatherText(temp, humidity) {
      var text = temp < 18 ? 'Cold' : (temp > 18 && temp < 30 ? 'Ambient' : 'Hot');
      text += humidity < 30 ? ' & Dry' : ' & Humid';
      return text;
    }

    function weatherTheme(temp, humidity) {
      var text = getWeatherText(temp, humidity);
      if (text.indexOf('Hot') === 0) {
        return { gradient: 'linear-gradient(105.58deg, #ffffff 68.87%, #FFEFD0 123.93%)', color: '#FFB100', border: '#fae4ba' };
      } else if (text.indexOf('Cold') === 0) {
        return { gradient: 'linear-gradient(105.58deg, #ffffff 68.87%, #A0F3F3 123.93%)', color: '#53BDBD', border: '#b8ecec' };
      } else {
        return { gradient: 'linear-gradient(105.58deg, #ffffff 68.87%, #FFD4E0 123.93%)', color: '#EA6F92', border: '#f5c0cf' };
      }
    }

    function weatherCopyForBucket(bucket) {
      if (bucket === 'hot') return 'Hot and humid weather means you lose fluids much more rapidly than usual.';
      if (bucket === 'moderate') return 'Moderate weather still increases fluid and sodium needs during running.';
      return 'Cool weather lowers heat stress but hydration and sodium still matter.';
    }

    function showWeatherConfirm(city, temp, humidity) {
      clearInlineError();
      state.city = city;
      state.temp = temp;
      state.humidity = humidity;
      state.weather = weatherBucket(temp);

      var condText = getWeatherText(temp, humidity);
      var theme = weatherTheme(temp, humidity);

      if (weatherCityEl) weatherCityEl.textContent = city;
      if (weatherTempEl) weatherTempEl.innerHTML = Math.round(temp) + '<span class="hc-deg">°</span><span class="hc-c">c</span>';
      if (weatherHumEl) weatherHumEl.textContent = 'Humidity: ' + Math.round(humidity) + '%';
      if (weatherCondEl) weatherCondEl.textContent = condText;
      if (weatherConfirmTitle) weatherConfirmTitle.innerHTML = "Looks like you're in<br><span class=\"hc-confirm-city\">" + city + ' :)</span>';
      if (weatherConfirmCopy) weatherConfirmCopy.textContent = weatherCopyForBucket(state.weather);

      // Apply dynamic theme to the weather card
      var weatherCard = weatherConfirm ? weatherConfirm.querySelector('.hc-weather-card') : null;
      if (weatherCard) {
        weatherCard.style.background = theme.gradient;
        weatherCard.style.color = theme.color;
        weatherCard.style.borderColor = theme.border;
      }
      var themedEls = weatherConfirm ? weatherConfirm.querySelectorAll('.hc-weather-city, .hc-weather-temp, .hc-weather-icon, .hc-weather-meta, .hc-weather-dot') : [];
      themedEls.forEach(function(el) { el.style.color = theme.color; });

      if (weatherSelect) weatherSelect.hidden = true;
      if (weatherConfirm) weatherConfirm.hidden = false;
      if (weatherProceedBtn) weatherProceedBtn.disabled = false;
    }

    function resetWeatherScreen() {
      if (weatherSelect) weatherSelect.hidden = false;
      if (weatherConfirm) weatherConfirm.hidden = true;
      state.weather = null;
      if (weatherProceedBtn) weatherProceedBtn.disabled = true;
    }

    var MUMBAI_FALLBACK = { temp: 32, humidity: 63, condition: '' };

    function fetchCityWeatherByName(city) {
      if (!weatherApiKey) {
        if (city === 'Mumbai') {
          showWeatherConfirm('Mumbai', MUMBAI_FALLBACK.temp, MUMBAI_FALLBACK.humidity);
        } else {
          setInlineError('Add OpenWeather API key in section settings to fetch live weather.');
        }
        return;
      }

      clearInlineError();
      fetch('https://api.openweathermap.org/data/2.5/weather?q=' + encodeURIComponent(city + ',IN') + '&appid=' + encodeURIComponent(weatherApiKey) + '&units=metric')
        .then(function(r) {
          if (r.status === 401) throw new Error('invalid_key');
          if (!r.ok) throw new Error('weather_error');
          return r.json();
        })
        .then(function(data) {
          showWeatherConfirm(city, data.main.temp, data.main.humidity || 0);
        })
        .catch(function(err) {
          if (city === 'Mumbai') {
            showWeatherConfirm('Mumbai', MUMBAI_FALLBACK.temp, MUMBAI_FALLBACK.humidity);
          } else if (err && err.message === 'invalid_key') {
            setInlineError('API key is invalid or not yet activated (new keys can take up to 2 hours). Please check your OpenWeather API key.');
          } else {
            setInlineError('Could not fetch weather for ' + city + '. Please try again.');
          }
        });
    }

    // Fetch weather by coordinates (used when a Google Places place_id is resolved)
    function fetchWeatherByCoords(lat, lng, cityName) {
      if (!weatherApiKey) {
        setInlineError('Add OpenWeather API key in section settings to fetch live weather.');
        return;
      }
      clearInlineError();
      fetch('https://api.openweathermap.org/data/2.5/weather?lat=' + lat + '&lon=' + lng + '&appid=' + encodeURIComponent(weatherApiKey) + '&units=metric')
        .then(function(r) {
          if (r.status === 401) throw new Error('invalid_key');
          if (!r.ok) throw new Error('weather_error');
          return r.json();
        })
        .then(function(data) {
          showWeatherConfirm(cityName, data.main.temp, data.main.humidity || 0);
        })
        .catch(function(err) {
          if (err && err.message === 'invalid_key') {
            setInlineError('API key is invalid or not yet activated. Please check your OpenWeather API key.');
          } else {
            setInlineError('Could not fetch weather for ' + cityName + '. Please try again.');
          }
        });
    }

    // Resolve a PlacePrediction → lat/lng → weather (main wizard)
    function geocodeAndFetchWeather(prediction, cityName) {
      if (!prediction) { fetchCityWeatherByName(cityName); return; }
      var place = prediction.toPlace();
      place.fetchFields({ fields: ['location', 'addressComponents'] })
        .then(function() {
          var resolvedCity = cityName;
          if (place.addressComponents) {
            var localityComp = place.addressComponents.find(function(c) { return c.types && c.types.indexOf('locality') !== -1; });
            var adminComp    = place.addressComponents.find(function(c) { return c.types && c.types.indexOf('administrative_area_level_2') !== -1; });
            resolvedCity = (localityComp || adminComp) ? (localityComp || adminComp).longText : cityName;
          }
          fetchWeatherByCoords(place.location.lat(), place.location.lng(), resolvedCity);
        })
        .catch(function() { fetchCityWeatherByName(cityName); });
    }

    // Resolve a PlacePrediction → lat/lng → weather (edit modal)
    function geocodeAndFetchWeatherForEdit(prediction, cityName) {
      if (!prediction) { fetchCityWeatherForEdit(cityName); return; }
      var place = prediction.toPlace();
      place.fetchFields({ fields: ['location', 'addressComponents'] })
        .then(function() {
          var resolvedCity = cityName;
          if (place.addressComponents) {
            var localityComp = place.addressComponents.find(function(c) { return c.types && c.types.indexOf('locality') !== -1; });
            var adminComp    = place.addressComponents.find(function(c) { return c.types && c.types.indexOf('administrative_area_level_2') !== -1; });
            resolvedCity = (localityComp || adminComp) ? (localityComp || adminComp).longText : cityName;
          }
          var loc = place.location;
          if (!weatherApiKey) {
            pendingEdit.city    = resolvedCity;
            pendingEdit.weather = 'moderate';
            if (editLocationNameEl) editLocationNameEl.textContent = resolvedCity;
            showEditSettingsView();
            checkPendingChanges();
            return;
          }
          fetch('https://api.openweathermap.org/data/2.5/weather?lat=' + loc.lat() + '&lon=' + loc.lng() + '&appid=' + encodeURIComponent(weatherApiKey) + '&units=metric')
            .then(function(r) { if (!r.ok) throw new Error('weather_error'); return r.json(); })
            .then(function(data) {
              pendingEdit.city    = resolvedCity;
              pendingEdit.weather = weatherBucket(data.main.temp);
              if (editLocationNameEl) editLocationNameEl.textContent = pendingEdit.city;
              showEditSettingsView();
              checkPendingChanges();
            })
            .catch(function() {
              pendingEdit.city    = resolvedCity;
              pendingEdit.weather = 'moderate';
              if (editLocationNameEl) editLocationNameEl.textContent = resolvedCity;
              showEditSettingsView();
              checkPendingChanges();
            });
        })
        .catch(function() { fetchCityWeatherForEdit(cityName); });
    }

    function fetchWeatherByGeo() {
      if (!weatherApiKey) {
        setInlineError('Add OpenWeather API key in section settings to use location detection.');
        return;
      }
      if (!navigator.geolocation) {
        setInlineError('Geolocation is not supported in this browser.');
        return;
      }

      clearInlineError();
      navigator.geolocation.getCurrentPosition(function(position) {
        var lat = position.coords.latitude;
        var lon = position.coords.longitude;

        // Fetch weather and city name in parallel
        var weatherPromise = fetch('https://api.openweathermap.org/data/2.5/weather?lat=' + lat + '&lon=' + lon + '&appid=' + encodeURIComponent(weatherApiKey) + '&units=metric')
          .then(function(r) {
            if (r.status === 401) throw new Error('invalid_key');
            if (!r.ok) throw new Error('weather_error');
            return r.json();
          });

        // Reverse geocode lat/lon using Google Maps JS Geocoder (key not exposed in network requests)
        var cityPromise = new Promise(function(resolve) {
          if (window.google && window.google.maps && window.google.maps.Geocoder) {
            var geocoder = new window.google.maps.Geocoder();
            geocoder.geocode({ location: { lat: lat, lng: lon } }, function(results, status) {
              if (status === 'OK' && results && results[0]) {
                var cityComp = results[0].address_components.find(function(c) {
                  return c.types.indexOf('locality') !== -1;
                });
                var adminComp = results[0].address_components.find(function(c) {
                  return c.types.indexOf('administrative_area_level_2') !== -1;
                });
                resolve((cityComp || adminComp) ? (cityComp || adminComp).long_name : results[0].formatted_address.split(',')[0]);
              } else {
                resolve(null);
              }
            });
          } else {
            resolve(null);
          }
        });

        Promise.all([weatherPromise, cityPromise])
          .then(function(results) {
            var data = results[0];
            var cityName = results[1] || 'your city';
            showWeatherConfirm(cityName, data.main.temp, data.main.humidity || 0);
          })
          .catch(function(err) {
            if (err && err.message === 'invalid_key') {
              setInlineError('API key is invalid or not yet activated (new keys can take up to 2 hours). Please check your OpenWeather API key.');
            } else {
              setInlineError('Could not fetch local weather right now. Please try again or pick a city manually.');
            }
          });
      }, function(err) {
        if (err && err.code === 1) {
          setInlineError('Location access was denied. Please allow location access in your browser or pick a city manually.');
        } else if (err && err.code === 2) {
          setInlineError('Your location could not be determined. Please pick a city manually.');
        } else {
          setInlineError('Location request timed out. Please pick a city manually.');
        }
      }, { timeout: 10000 });
    }

    function goToStep(step) {
      var nextStep = Math.max(1, Math.min(totalSteps, step));
      currentStep = nextStep;

      stepPanels.forEach(function(panel) {
        panel.classList.toggle('is-active', parseInt(panel.dataset.stepIndex, 10) === nextStep);
      });

      if (stepProgress) stepProgress.textContent = String(nextStep);

      if (nextStep === 4) resetWeatherScreen();
      if (nextStep === 2) {
        requestAnimationFrame(function() {
          applyIntensityUI();
        });
      }
    }

    // ── Product card setup ──────────────────────────────
    var recCard      = document.getElementById('hc-rec-card-'        + sid);
    var stepperNum   = document.getElementById('hc-stepper-num-'     + sid);
    var stepMinus    = document.getElementById('hc-stepper-minus-'   + sid);
    var stepPlus     = document.getElementById('hc-stepper-plus-'    + sid);
    var priceTotal   = document.getElementById('hc-rec-price-total-' + sid);
    var unitPriceEl  = document.getElementById('hc-rec-unit-price-'  + sid);
    var addBtn       = document.getElementById('hc-add-to-cart-'     + sid);
    var buyBtn       = document.getElementById('hc-buy-now-'         + sid);
    // flavor pill elements
    var pillGuava    = document.getElementById('hc-rec-pill-guava-'  + sid);
    var pillLime     = document.getElementById('hc-rec-pill-lime-'   + sid);
    // cover images
    var coverGuava   = document.getElementById('hc-rec-cover-img-'       + sid);
    var coverLime    = document.getElementById('hc-rec-cover-img-lime-'  + sid);
    // title element
    var recTitleEl   = document.getElementById('hc-rec-title-'           + sid);

    var currentQty     = 1;
    var selectedFlavor = 'guava';

    function updateRecCard(qty) {
      currentQty = Math.max(1, qty);
      if (stepperNum) stepperNum.textContent = currentQty;

      if (!recCard) return;
      var guavaPrice = parseInt(recCard.dataset.guavaPrice || '257', 10);
      var limePrice  = parseInt(recCard.dataset.limePrice  || '257', 10);
      var unitPrice  = selectedFlavor === 'lime' ? limePrice : guavaPrice;
      var total      = unitPrice * currentQty;

      if (priceTotal)  priceTotal.textContent  = formatPrice(total);
      if (unitPriceEl) unitPriceEl.textContent = '₹ ' + Math.round(unitPrice / 10) + ' / sachet';
    }

    function switchFlavor(flavor) {
      selectedFlavor = flavor;
      if (pillGuava) pillGuava.classList.toggle('is-selected', flavor === 'guava');
      if (pillLime)  pillLime.classList.toggle('is-selected',  flavor === 'lime');
      // swap cover image
      if (coverGuava) coverGuava.style.display = flavor === 'guava' ? '' : 'none';
      if (coverLime)  coverLime.style.display  = flavor === 'lime'  ? '' : 'none';
      // swap card heading
      if (recTitleEl && recCard) {
        var heading = flavor === 'lime' ? recCard.dataset.limeHeading : recCard.dataset.guavaHeading;
        if (heading) recTitleEl.textContent = heading;
      }
      updateRecCard(currentQty);
    }

    function showRecCard(baseQty) {
      if (!recCard) return;
      updateRecCard(baseQty);
      recCard.hidden = false;
      requestAnimationFrame(function() { recCard.classList.add('is-visible'); });
    }

    function hideRecCard() {
      if (!recCard) return;
      recCard.classList.remove('is-visible');
      recCard.hidden = true;
    }

    // Flavor pill click handlers
    if (pillGuava) pillGuava.addEventListener('click', function() { switchFlavor('guava'); });
    if (pillLime)  pillLime.addEventListener('click',  function() { switchFlavor('lime');  });

    function buildItems() {
      if (!recCard) return [];
      var guavaId = recCard.dataset.guavaId;
      var limeId  = recCard.dataset.limeId;
      var pickId  = selectedFlavor === 'lime' ? limeId : guavaId;
      var items   = [];
      if (pickId) items.push({ id: parseInt(pickId, 10), quantity: currentQty });
      return items;
    }

    // Add to cart — AJAX, opens cart drawer exactly like product page does
    function cartPost() {
      var items = buildItems();
      if (items.length === 0) return;
      if (addBtn) addBtn.classList.add('is-loading');

      // Collect section IDs the cart drawer needs to re-render (same pattern as theme's ProductForm)
      var sectionsToBundle = new Set();
      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
        bubbles: true,
        detail: { sections: sectionsToBundle }
      }));

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items, sections: Array.from(sectionsToBundle).join(',') })
      })
      .then(function(res) {
        if (!res.ok) throw new Error('cart_error');
        return res.json();
      })
      .then(function(addData) {
        // Fetch updated cart state, then merge bundled section HTML from add response
        return fetch('/cart.js')
          .then(function(r) { return r.json(); })
          .then(function(cartData) {
            cartData.sections = addData.sections;
            // Dispatching with baseEvent "variant:add" triggers the cart drawer to open
            document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
              bubbles: true,
              detail: { baseEvent: 'variant:add', cart: cartData }
            }));
            if (addBtn) addBtn.classList.remove('is-loading');
          });
      })
      .catch(function() {
        if (addBtn) {
          addBtn.classList.remove('is-loading');
          var origErr = addBtn.innerHTML;
          addBtn.textContent = '✗ failed — check variant IDs';
          setTimeout(function() { addBtn.innerHTML = origErr; }, 3000);
        }
      });
    }

    // Buy now, adds only these items, goes straight to checkout
    function buyNow() {
      var items = buildItems();
      if (items.length === 0) return;
      if (buyBtn) buyBtn.classList.add('is-loading');

      // Free gift: this checkout bypasses the cart (and free-gift.js), so the
      // sipper has to ride along here when the order alone crosses the
      // threshold. Prices in the dataset are rupees; FreeGift threshold is paise.
      var fg = window.FreeGift;
      if (fg && fg.ELIGIBLE && recCard) {
        var unitPrice = parseFloat(selectedFlavor === 'lime' ? recCard.dataset.limePrice : recCard.dataset.guavaPrice) || 0;
        if (unitPrice * currentQty * 100 >= fg.THRESHOLD_PAISE) {
          var giftProps = {};
          giftProps[fg.GIFT_PROP] = 'true';
          items.push({ id: Number(fg.GIFT_VARIANT_ID), quantity: 1, properties: giftProps });
        }
      }

      var token = recCard ? (recCard.dataset.storefrontToken || '') : '';

      var userEmail = state.email || '';
      var userName  = state.name  || '';
      var nameParts = userName.trim().split(/\s+/);
      var firstName = nameParts[0] || '';
      var lastName  = nameParts.slice(1).join(' ') || '';

      if (!token) {
        // Fallback (no token configured): add to cart and go to /checkout
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        })
        .then(function(res) { if (!res.ok) throw new Error(); return res.json(); })
        .then(function() {
          var url = new URL('/checkout', window.location.origin);
          if (userEmail) url.searchParams.set('checkout[email]', userEmail);
          if (firstName) url.searchParams.set('checkout[shipping_address][first_name]', firstName);
          if (lastName)  url.searchParams.set('checkout[shipping_address][last_name]',  lastName);
          window.location = url.toString();
        })
        .catch(function() { if (buyBtn) buyBtn.classList.remove('is-loading'); });
        return;
      }

      // Storefront API: create an independent cart+checkout (does NOT touch the customer's cart)
      var lines = items.map(function(item) {
        var line = { merchandiseId: 'gid://shopify/ProductVariant/' + item.id, quantity: item.quantity };
        if (item.properties) {
          line.attributes = Object.keys(item.properties).map(function(key) {
            return { key: key, value: String(item.properties[key]) };
          });
        }
        return line;
      });

      var cartInput = { lines: lines };
      if (userEmail) cartInput.buyerIdentity = { email: userEmail };

      fetch(window.location.origin + '/api/2024-01/graphql.json', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Shopify-Storefront-Access-Token': token
        },
        body: JSON.stringify({
          query: 'mutation cartCreate($input: CartInput!) { cartCreate(input: $input) { cart { checkoutUrl } userErrors { message } } }',
          variables: { input: cartInput }
        })
      })
      .then(function(res) { if (!res.ok) throw new Error(); return res.json(); })
      .then(function(data) {
        var errors = data.data.cartCreate.userErrors;
        if (errors && errors.length) throw new Error(errors[0].message);
        var checkoutUrl = new URL(data.data.cartCreate.cart.checkoutUrl);
        if (firstName) checkoutUrl.searchParams.set('checkout[shipping_address][first_name]', firstName);
        if (lastName)  checkoutUrl.searchParams.set('checkout[shipping_address][last_name]',  lastName);
        window.location = checkoutUrl.toString();
      })
      .catch(function() {
        if (buyBtn) {
          buyBtn.classList.remove('is-loading');
          var origErr = buyBtn.innerHTML;
          buyBtn.textContent = '✗ failed — check token or variant IDs';
          setTimeout(function() { buyBtn.innerHTML = origErr; }, 3000);
        }
      });
    }

    if (stepMinus) stepMinus.addEventListener('click', function() { updateRecCard(currentQty - 1); });
    if (stepPlus)  stepPlus.addEventListener('click',  function() { updateRecCard(currentQty + 1); });
    if (addBtn)    addBtn.addEventListener('click',    function() { cartPost(); });
    if (buyBtn)    buyBtn.addEventListener('click',    function() { buyNow();   });
    // ────────────────────────────────────────────────────

    // ── Duration counter ─────────────────────────────────
    var durationCounter = document.getElementById('hc-duration-counter-' + sid);
    var hoursInput = document.getElementById('hc-counter-hours-' + sid);
    var minutesInput = document.getElementById('hc-counter-minutes-' + sid);
    var durationProceedBtn = document.getElementById('hc-duration-proceed-' + sid);

    function durationBucket(hours, minutes) {
      var totalMin = hours * 60 + minutes;
      if (totalMin < 60) return 'lt1';
      if (totalMin <= 120) return '1to2';
      if (totalMin <= 180) return '2to3';
      return '3plus';
    }

    function padTwo(n) { return (n < 10 ? '0' : '') + n; }

    function clampInput(input) {
      var val = parseInt(input.value, 10);
      var min = parseInt(input.min, 10);
      var max = parseInt(input.max, 10);
      if (isNaN(val) || val < min) val = min;
      if (val > max) val = max;
      input.value = val;
      return val;
    }

    function syncCounterToInput(counterEl, unit, value, smooth) {
      var scrollEl = counterEl ? counterEl.querySelector('.hc-counter-scroll[data-unit="' + unit + '"]') : null;
      if (!scrollEl) return;
      var items = scrollEl.querySelectorAll('.hc-counter-item');
      var center = scrollEl.scrollTop + scrollEl.clientHeight / 2;
      var candidates = [];
      items.forEach(function(item) {
        if (parseInt(item.dataset.value, 10) === value) candidates.push(item);
      });

      if (!candidates.length) return;

      var selected = candidates[Math.floor(candidates.length / 2)];
      var bestDist = Infinity;
      candidates.forEach(function(item) {
        var itemCenter = item.offsetTop - scrollEl.offsetTop + item.clientHeight / 2;
        var dist = Math.abs(center - itemCenter);
        if (dist < bestDist) {
          bestDist = dist;
          selected = item;
        }
      });

      items.forEach(function(item) {
        item.classList.toggle('is-active', item === selected);
      });

      var scrollTop = selected.offsetTop - scrollEl.offsetTop - (scrollEl.clientHeight / 2) + (selected.clientHeight / 2);
      var maxScroll = scrollEl.scrollHeight - scrollEl.clientHeight;
      var target = Math.max(0, Math.min(maxScroll, scrollTop));
      if (smooth) {
        scrollEl.scrollTo({ top: target, behavior: 'smooth' });
      } else {
        scrollEl.scrollTop = target;
      }
    }

    function syncScrollToInput(unit, value, smooth) {
      syncCounterToInput(durationCounter, unit, value, smooth);
    }

    function updateDurationState(reformat) {
      var h = parseInt(hoursInput ? hoursInput.value : '0', 10);
      var m = parseInt(minutesInput ? minutesInput.value : '0', 10);
      if (isNaN(h)) h = 0;
      if (isNaN(m)) m = 0;
      h = Math.max(parseInt(hoursInput ? hoursInput.min : '0', 10), Math.min(parseInt(hoursInput ? hoursInput.max : '23', 10), h));
      m = Math.max(parseInt(minutesInput ? minutesInput.min : '0', 10), Math.min(parseInt(minutesInput ? minutesInput.max : '59', 10), m));
      if (reformat) {
        if (hoursInput) hoursInput.value = padTwo(h);
        if (minutesInput) minutesInput.value = padTwo(m);
      }
      state.duration = durationBucket(h, m);
      syncScrollToInput('hours', h);
      syncScrollToInput('minutes', m);
      if (durationProceedBtn) durationProceedBtn.disabled = (h === 0 && m === 0);
    }

    if (durationCounter) {
      // Arrow buttons (desktop + mobile)
      durationCounter.querySelectorAll('.hc-counter-col').forEach(function(col) {
        var unit = col.dataset.unit;
        var input = unit === 'hours' ? hoursInput : minutesInput;

        col.querySelector('.hc-counter-arrow--up').addEventListener('click', function() {
          var cur = parseInt(input.value, 10);
          var max = parseInt(input.max, 10);
          var val;
          if (unit === 'minutes') {
            val = (Math.floor(cur / 5) * 5) + 5;
            if (val > max) val = 0;
          } else {
            val = cur + 1;
            if (val > max) val = max;
          }
          input.value = val;
          updateDurationState(true);
        });

        col.querySelector('.hc-counter-arrow--down').addEventListener('click', function() {
          var cur = parseInt(input.value, 10);
          var min = parseInt(input.min, 10);
          var max = parseInt(input.max, 10);
          var val;
          if (unit === 'minutes') {
            val = (Math.ceil(cur / 5) * 5) - 5;
            if (val < min) val = 55;
          } else {
            val = cur - 1;
            if (val < min) val = min;
          }
          input.value = val;
          updateDurationState(true);
        });
      });

      // Typing in inputs (desktop)
      [hoursInput, minutesInput].forEach(function(input) {
        input.addEventListener('input', function() { updateDurationState(false); });
        input.addEventListener('blur', function() {
          updateDurationState(true);
        });
        input.addEventListener('focus', function() { input.select(); });
        input.addEventListener('click', function() { input.select(); });
        input.addEventListener('keydown', function(e) {
          if (e.key >= '0' && e.key <= '9') {
            if (input.selectionStart === input.selectionEnd && input.value.length >= parseInt(input.maxLength, 10)) {
              input.value = '';
            }
          }
        });
      });

      // Scroll snap (mobile)
      durationCounter.querySelectorAll('.hc-counter-scroll').forEach(function(scrollEl) {
        var unit = scrollEl.dataset.unit;
        var input = unit === 'hours' ? hoursInput : minutesInput;
        var debounce = null;

        scrollEl.addEventListener('scroll', function() {
          clearTimeout(debounce);
          debounce = setTimeout(function() {
            var items = scrollEl.querySelectorAll('.hc-counter-item');
            var scrollCenter = scrollEl.scrollTop + scrollEl.clientHeight / 2;
            var closest = null;
            var closestDist = Infinity;

            items.forEach(function(item) {
              var itemCenter = item.offsetTop - scrollEl.offsetTop + item.clientHeight / 2;
              var dist = Math.abs(scrollCenter - itemCenter);
              if (dist < closestDist) { closestDist = dist; closest = item; }
            });

            if (closest) {
              items.forEach(function(it) { it.classList.remove('is-active'); });
              closest.classList.add('is-active');
              input.value = parseInt(closest.dataset.value, 10);
              updateDurationState(true);
            }
          }, 60);
        });
      });

      // Format inputs on load
      updateDurationState(true);
    }

    if (durationProceedBtn) {
      durationProceedBtn.addEventListener('click', function() {
        updateDurationState(true);
        goToStep(2);
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    }

    if (cityGrid) {
      cityGrid.addEventListener('click', function(e) {
        var cityBtn = e.target.closest('.hc-city-pill');
        if (!cityBtn) return;
        cityGrid.querySelectorAll('.hc-city-pill').forEach(function(b) { b.classList.remove('is-selected'); });
        cityBtn.classList.add('is-selected');
        fetchCityWeatherByName(cityBtn.dataset.city);
      });
    }

    // ── Location Search Modal ─────────────────────────────
    var weatherSearchTrigger = document.getElementById('hc-weather-search-trigger-' + sid);
    var searchModalBackdrop  = document.getElementById('hc-search-modal-backdrop-' + sid);
    var searchModalCloseBtn  = document.getElementById('hc-search-modal-close-' + sid);
    var searchModalInput     = document.getElementById('hc-search-modal-input-' + sid);
    var searchSuggestionsEl  = document.getElementById('hc-search-suggestions-' + sid);
    var searchDebounceTimer  = null;

    function openSearchModal() {
      if (!searchModalBackdrop) return;
      searchModalBackdrop.hidden = false;
      searchModalBackdrop.removeAttribute('aria-hidden');
      document.body.style.overflow = 'hidden';
      if (searchModalInput) { searchModalInput.value = ''; searchModalInput.focus(); }
      if (searchSuggestionsEl) searchSuggestionsEl.innerHTML = '';
    }

    function closeSearchModal() {
      if (!searchModalBackdrop) return;
      searchModalBackdrop.hidden = true;
      searchModalBackdrop.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    function renderSearchSuggestions(results) {
      if (!searchSuggestionsEl) return;
      searchSuggestionsEl.innerHTML = '';
      results.forEach(function(item) {
        var isGooglePlace = !!(item.placePrediction);
        var city, sub, prediction;
        if (isGooglePlace) {
          prediction = item.placePrediction;
          city = prediction.mainText ? prediction.mainText.text : prediction.text.text.split(',')[0].trim();
          sub  = prediction.secondaryText ? prediction.secondaryText.text : '';
        } else {
          var addr = item.address || {};
          city = addr.city || addr.town || addr.village || addr.county || item.name || item.display_name.split(',')[0].trim();
          var parts = [addr.state_district || addr.county, addr.state].filter(Boolean);
          sub  = parts.length ? parts.join(', ') : item.display_name.split(',').slice(1, 3).join(',').trim();
          prediction = null;
        }

        var btn = document.createElement('button');
        btn.className = 'hc-search-suggestion';
        btn.type = 'button';
        btn.innerHTML =
          '<span class="hc-suggestion-pin">' +
            '<svg width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 0C2.69 0 0 2.69 0 6c0 4.5 6 10 6 10s6-5.5 6-10c0-3.31-2.69-6-6-6zm0 8.5A2.5 2.5 0 1 1 6 3.5a2.5 2.5 0 0 1 0 5z" fill="#a7a7a7"/></svg>' +
          '</span>' +
          '<span class="hc-suggestion-text">' +
            '<span class="hc-suggestion-name">' + city + '</span>' +
            '<span class="hc-suggestion-sub">' + sub + '</span>' +
          '</span>';
        btn.addEventListener('click', function() {
          closeSearchModal();
          if (prediction) {
            geocodeAndFetchWeather(prediction, city);
          } else {
            fetchCityWeatherByName(city);
          }
        });
        searchSuggestionsEl.appendChild(btn);
      });
    }

    if (weatherSearchTrigger) {
      weatherSearchTrigger.addEventListener('click', openSearchModal);
    }

    if (searchModalCloseBtn) {
      searchModalCloseBtn.addEventListener('click', closeSearchModal);
    }

    if (searchModalBackdrop) {
      searchModalBackdrop.addEventListener('click', function(e) {
        if (e.target === searchModalBackdrop) closeSearchModal();
      });
    }

    if (searchModalInput) {
      searchModalInput.addEventListener('input', function() {
        clearTimeout(searchDebounceTimer);
        var q = searchModalInput.value.trim();
        if (!q) { if (searchSuggestionsEl) searchSuggestionsEl.innerHTML = ''; return; }
        searchDebounceTimer = setTimeout(function() {
          if (gmapsReady) {
            google.maps.places.AutocompleteSuggestion.fetchAutocompleteSuggestions(
              { input: q }
            )
              .then(function(response) {
                renderSearchSuggestions(response && response.suggestions ? response.suggestions : []);
              })
              .catch(function() { renderSearchSuggestions([]); });
          } else {
            // Fallback: Nominatim (OpenStreetMap) — used when no Google Maps key is set
            fetch('https://nominatim.openstreetmap.org/search?q=' + encodeURIComponent(q) + '&format=json&limit=5&addressdetails=1', {
              headers: { 'Accept-Language': 'en' }
            })
              .then(function(r) { return r.json(); })
              .then(function(data) { renderSearchSuggestions(data); })
              .catch(function() {});
          }
        }, 350);
      });
    }

    if (detectBtn) {
      detectBtn.addEventListener('click', function() {
        fetchWeatherByGeo();
      });
    }

    if (weatherBackBtn) {
      weatherBackBtn.addEventListener('click', function() {
        resetWeatherScreen();
      });
    }

    var modalBackdrop   = document.getElementById('hc-modal-backdrop-'  + sid);
    var modalCloseBtn   = document.getElementById('hc-modal-close-'     + sid);
    var modalNameInput  = document.getElementById('hc-modal-name-'      + sid);
    var modalEmailInput = document.getElementById('hc-modal-email-'     + sid);
    var modalSubmitBtn  = document.getElementById('hc-modal-submit-'    + sid);

    function updateModalSubmitState() {
      if (!modalSubmitBtn) return;
      var nameOk  = modalNameInput  && modalNameInput.value.trim().length  > 0;
      var emailOk = modalEmailInput && modalEmailInput.value.trim().length > 0;
      modalSubmitBtn.disabled = !(nameOk && emailOk);
    }

    function openModal() {
      if (!modalBackdrop) return;
      if (modalNameInput)  modalNameInput.value  = '';
      if (modalEmailInput) modalEmailInput.value = '';
      updateModalSubmitState();
      modalBackdrop.hidden = false;
      modalBackdrop.removeAttribute('aria-hidden');
      document.body.style.overflow = 'hidden';
      if (modalNameInput) modalNameInput.focus();
    }

    function closeModal() {
      if (!modalBackdrop) return;
      modalBackdrop.hidden = true;
      modalBackdrop.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    if (weatherProceedBtn) {
      weatherProceedBtn.addEventListener('click', function() {
        if (!state.weather) return;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        openModal();
      });
    }

    if (modalCloseBtn) {
      modalCloseBtn.addEventListener('click', closeModal);
    }

    if (modalBackdrop) {
      modalBackdrop.addEventListener('click', function(e) {
        if (e.target === modalBackdrop) closeModal();
      });
    }

    if (modalNameInput)  modalNameInput.addEventListener('input',  updateModalSubmitState);
    if (modalEmailInput) modalEmailInput.addEventListener('input', updateModalSubmitState);

    if (modalSubmitBtn) {
      modalSubmitBtn.addEventListener('click', function() {
        if (modalSubmitBtn.disabled) return;
        var name  = modalNameInput  ? modalNameInput.value.trim()  : '';
        var email = modalEmailInput ? modalEmailInput.value.trim() : '';
        state.name  = name  || null;
        state.email = email || null;
        if (els.greeting) {
          els.greeting.textContent = name ? 'Hey ' + name + ',' : 'Hey there,';
        }
        closeModal();
        window.scrollTo({ top: 0, behavior: 'smooth' });
        calculate();
      });
    }

    if (modalNameInput) {
      modalNameInput.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' && !modalSubmitBtn.disabled) modalSubmitBtn && modalSubmitBtn.click();
      });
    }
    if (modalEmailInput) {
      modalEmailInput.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' && !modalSubmitBtn.disabled) modalSubmitBtn && modalSubmitBtn.click();
      });
    }

    // ── Edit Modal (duration + intensity + sweat + location) ─
    var editModalBackdrop    = document.getElementById('hc-edit-modal-backdrop-'   + sid);
    var editSettingsView     = document.getElementById('hc-edit-settings-view-'    + sid);
    var editLocationView     = document.getElementById('hc-edit-location-view-'    + sid);
    var editCloseBtn         = document.getElementById('hc-edit-close-'            + sid);
    var editLocationRow      = document.getElementById('hc-edit-location-row-'     + sid);
    var editLocationNameEl   = document.getElementById('hc-edit-location-name-'    + sid);
    var editDurationCounter  = document.getElementById('hc-edit-duration-counter-' + sid);
    var editHoursInput       = document.getElementById('hc-edit-counter-hours-'    + sid);
    var editMinutesInput     = document.getElementById('hc-edit-counter-minutes-'  + sid);
    var editBackBtn          = document.getElementById('hc-edit-back-btn-'         + sid);
    var editLocationCloseBtn = document.getElementById('hc-edit-location-close-'   + sid);
    var editSearchInput      = document.getElementById('hc-edit-search-input-'     + sid);
    var editSuggestionsEl    = document.getElementById('hc-edit-suggestions-'      + sid);
    var editUpdateFooter     = document.getElementById('hc-edit-update-footer-'    + sid);
    var editUpdateBtn        = document.getElementById('hc-edit-update-btn-'       + sid);
    var editDebounceTimer    = null;

    // pendingEdit: tracks in-modal changes before user clicks Update
    var pendingEdit = {};

    function openEditModal() {
      if (!editModalBackdrop) return;
      // Snapshot current state into pending
      var curH = hoursInput   ? parseInt(hoursInput.value, 10)   : 1;
      var curM = minutesInput ? parseInt(minutesInput.value, 10) : 0;
      pendingEdit = {
        hours:     curH,
        minutes:   curM,
        intensity: state.intensity,
        sweat:     state.sweat,
        city:      state.city,
        weather:   state.weather
      };
      // Populate pills
      editModalBackdrop.querySelectorAll('.hc-edit-pill[data-group="intensity"]').forEach(function(b) {
        b.classList.toggle('is-selected', b.dataset.value === pendingEdit.intensity);
      });
      editModalBackdrop.querySelectorAll('.hc-edit-pill[data-group="sweat"]').forEach(function(b) {
        b.classList.toggle('is-selected', b.dataset.value === pendingEdit.sweat);
      });
      // Populate location
      if (editLocationNameEl) editLocationNameEl.textContent = pendingEdit.city || '—';
      showEditSettingsView();
      editModalBackdrop.hidden = false;
      editModalBackdrop.removeAttribute('aria-hidden');
      document.body.style.overflow = 'hidden';

      requestAnimationFrame(function() {
        if (editHoursInput) editHoursInput.value = padTwo(curH);
        if (editMinutesInput) editMinutesInput.value = padTwo(curM);
        updateEditDurationState(false);
        // Double rAF to ensure the modal is fully laid out before syncing scroll positions
        requestAnimationFrame(function() {
          syncCounterToInput(editDurationCounter, 'hours', curH);
          syncCounterToInput(editDurationCounter, 'minutes', curM);
        });
      });
    }

    function closeEditModal() {
      if (!editModalBackdrop) return;
      editModalBackdrop.hidden = true;
      editModalBackdrop.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (editSearchInput) editSearchInput.value = '';
      if (editSuggestionsEl) editSuggestionsEl.innerHTML = '';
    }

    function checkPendingChanges() {
      if (!editUpdateFooter || !editUpdateBtn) return;
      var curH = hoursInput   ? parseInt(hoursInput.value, 10)   : 1;
      var curM = minutesInput ? parseInt(minutesInput.value, 10) : 0;
      var changed = (
        pendingEdit.hours     !== curH            ||
        pendingEdit.minutes   !== curM            ||
        pendingEdit.intensity !== state.intensity ||
        pendingEdit.sweat     !== state.sweat     ||
        pendingEdit.city      !== state.city
      );
      editUpdateFooter.hidden = !changed;
      editUpdateBtn.disabled = !changed;
    }

    function showEditSettingsView() {
      if (editSettingsView) editSettingsView.hidden = false;
      if (editLocationView) editLocationView.hidden = true;
      checkPendingChanges();
    }

    function showEditLocationView() {
      if (editSettingsView) editSettingsView.hidden = true;
      if (editLocationView) editLocationView.hidden = false;
      if (editUpdateFooter) editUpdateFooter.hidden = true;
      if (editSearchInput) { editSearchInput.value = ''; editSearchInput.focus(); }
      if (editSuggestionsEl) editSuggestionsEl.innerHTML = '';
    }

    function updateEditDurationState(reformat) {
      if (!editHoursInput || !editMinutesInput) return;
      var h = parseInt(editHoursInput.value, 10);
      var m = parseInt(editMinutesInput.value, 10);
      if (isNaN(h)) h = 0;
      if (isNaN(m)) m = 0;
      h = Math.max(parseInt(editHoursInput.min, 10), Math.min(parseInt(editHoursInput.max, 10), h));
      m = Math.max(parseInt(editMinutesInput.min, 10), Math.min(parseInt(editMinutesInput.max, 10), m));
      if (reformat) {
        editHoursInput.value = padTwo(h);
        editMinutesInput.value = padTwo(m);
      }
      pendingEdit.hours = h;
      pendingEdit.minutes = m;
      syncCounterToInput(editDurationCounter, 'hours', h);
      syncCounterToInput(editDurationCounter, 'minutes', m);
      checkPendingChanges();
    }

    if (editDurationCounter && editHoursInput && editMinutesInput) {
      editDurationCounter.querySelectorAll('.hc-counter-col').forEach(function(col) {
        var unit = col.dataset.unit;
        var input = unit === 'hours' ? editHoursInput : editMinutesInput;

        col.querySelector('.hc-counter-arrow--up').addEventListener('click', function() {
          var cur = parseInt(input.value, 10);
          var max = parseInt(input.max, 10);
          var val;
          if (unit === 'minutes') {
            val = (Math.floor(cur / 5) * 5) + 5;
            if (val > max) val = 0;
          } else {
            val = cur + 1;
            if (val > max) val = max;
          }
          input.value = val;
          updateEditDurationState(true);
        });

        col.querySelector('.hc-counter-arrow--down').addEventListener('click', function() {
          var cur = parseInt(input.value, 10);
          var min = parseInt(input.min, 10);
          var max = parseInt(input.max, 10);
          var val;
          if (unit === 'minutes') {
            val = (Math.ceil(cur / 5) * 5) - 5;
            if (val < min) val = 55;
          } else {
            val = cur - 1;
            if (val < min) val = min;
          }
          input.value = val;
          updateEditDurationState(true);
        });
      });

      [editHoursInput, editMinutesInput].forEach(function(input) {
        input.addEventListener('input', function() { updateEditDurationState(false); });
        input.addEventListener('blur', function() {
          updateEditDurationState(true);
        });
        input.addEventListener('focus', function() { input.select(); });
        input.addEventListener('click', function() { input.select(); });
        input.addEventListener('keydown', function(e) {
          if (e.key >= '0' && e.key <= '9') {
            if (input.selectionStart === input.selectionEnd && input.value.length >= parseInt(input.maxLength, 10)) {
              input.value = '';
            }
          }
        });
      });

      editDurationCounter.querySelectorAll('.hc-counter-scroll').forEach(function(scrollEl) {
        var unit = scrollEl.dataset.unit;
        var input = unit === 'hours' ? editHoursInput : editMinutesInput;
        var debounce = null;

        scrollEl.addEventListener('scroll', function() {
          clearTimeout(debounce);
          debounce = setTimeout(function() {
            var items = scrollEl.querySelectorAll('.hc-counter-item');
            var scrollCenter = scrollEl.scrollTop + scrollEl.clientHeight / 2;
            var closest = null;
            var closestDist = Infinity;

            items.forEach(function(item) {
              var itemCenter = item.offsetTop - scrollEl.offsetTop + item.clientHeight / 2;
              var dist = Math.abs(scrollCenter - itemCenter);
              if (dist < closestDist) { closestDist = dist; closest = item; }
            });

            if (closest) {
              items.forEach(function(it) { it.classList.remove('is-active'); });
              closest.classList.add('is-active');
              input.value = parseInt(closest.dataset.value, 10);
              updateEditDurationState(true);
            }
          }, 60);
        });
      });
    }

    // Intensity pill selection
    if (editSettingsView) {
      editSettingsView.querySelectorAll('.hc-edit-pill[data-group="intensity"]').forEach(function(btn) {
        btn.addEventListener('click', function() {
          editSettingsView.querySelectorAll('.hc-edit-pill[data-group="intensity"]').forEach(function(b) { b.classList.remove('is-selected'); });
          btn.classList.add('is-selected');
          pendingEdit.intensity = btn.dataset.value;
          checkPendingChanges();
        });
      });
    }

    // Sweat pill selection
    if (editSettingsView) {
      editSettingsView.querySelectorAll('.hc-edit-pill[data-group="sweat"]').forEach(function(btn) {
        btn.addEventListener('click', function() {
          editSettingsView.querySelectorAll('.hc-edit-pill[data-group="sweat"]').forEach(function(b) { b.classList.remove('is-selected'); });
          btn.classList.add('is-selected');
          pendingEdit.sweat = btn.dataset.value;
          checkPendingChanges();
        });
      });
    }

    // Update button → apply pending to state + recalculate
    if (editUpdateBtn) {
      editUpdateBtn.addEventListener('click', function() {
        // Apply duration
        if (hoursInput)   { hoursInput.value   = padTwo(pendingEdit.hours);   }
        if (minutesInput) { minutesInput.value = padTwo(pendingEdit.minutes); }
        updateDurationState(false);
        // Apply intensity
        state.intensity = pendingEdit.intensity;
        // Sync intensity slider visual
        if (intensitySlider) {
          intensitySlider.value = pendingEdit.intensity === 'easy' ? '0' : pendingEdit.intensity === 'moderate' ? '50' : '100';
          applyIntensityUI();
        }
        // Apply sweat
        state.sweat = pendingEdit.sweat;
        // Sync wizard sweat pills
        wizard.querySelectorAll('.hc-pill[data-group="sweat"]').forEach(function(b) {
          b.classList.toggle('is-selected', b.dataset.value === state.sweat);
        });
        // Always apply location — pendingEdit snapshots state at open time,
        // so this is a no-op if nothing changed, but ensures state.weather
        // is never lost (e.g. if goToStep(4) nulled it during init).
        state.city    = pendingEdit.city || state.city;
        state.weather = pendingEdit.weather || state.weather;
        closeEditModal();
        calculate();
      });
    }

    if (editCloseBtn)         editCloseBtn.addEventListener('click', closeEditModal);
    if (editLocationCloseBtn) editLocationCloseBtn.addEventListener('click', closeEditModal);

    if (editModalBackdrop) {
      editModalBackdrop.addEventListener('click', function(e) {
        if (e.target === editModalBackdrop) closeEditModal();
      });
    }

    if (editLocationRow) editLocationRow.addEventListener('click', showEditLocationView);
    if (editBackBtn)     editBackBtn.addEventListener('click', showEditSettingsView);

    // City fetch for edit modal → stores in pending + returns to settings view
    function fetchCityWeatherForEdit(city) {
      if (!weatherApiKey) {
        pendingEdit.city    = city;
        pendingEdit.weather = 'moderate';
        if (editLocationNameEl) editLocationNameEl.textContent = city;
        showEditSettingsView();
        checkPendingChanges();
        return;
      }
      fetch('https://api.openweathermap.org/data/2.5/weather?q=' + encodeURIComponent(city + ',IN') + '&appid=' + encodeURIComponent(weatherApiKey) + '&units=metric')
        .then(function(r) {
          if (!r.ok) throw new Error('weather_error');
          return r.json();
        })
        .then(function(data) {
          pendingEdit.city    = city;
          pendingEdit.weather = weatherBucket(data.main.temp);
          if (editLocationNameEl) editLocationNameEl.textContent = pendingEdit.city;
          showEditSettingsView();
          checkPendingChanges();
        })
        .catch(function() {
          pendingEdit.city    = city;
          pendingEdit.weather = 'moderate';
          if (editLocationNameEl) editLocationNameEl.textContent = city;
          showEditSettingsView();
          checkPendingChanges();
        });
    }

    function renderEditSuggestions(results) {
      if (!editSuggestionsEl) return;
      editSuggestionsEl.innerHTML = '';
      results.forEach(function(item) {
        var isGooglePlace = !!(item.placePrediction);
        var city, sub, prediction;
        if (isGooglePlace) {
          prediction = item.placePrediction;
          city = prediction.mainText ? prediction.mainText.text : prediction.text.text.split(',')[0].trim();
          sub  = prediction.secondaryText ? prediction.secondaryText.text : '';
        } else {
          var addr = item.address || {};
          city = addr.city || addr.town || addr.village || addr.county || item.name || item.display_name.split(',')[0].trim();
          var parts = [addr.state_district || addr.county, addr.state].filter(Boolean);
          sub  = parts.length ? parts.join(', ') : item.display_name.split(',').slice(1, 3).join(',').trim();
          prediction = null;
        }

        var btn = document.createElement('button');
        btn.className = 'hc-search-suggestion';
        btn.type = 'button';
        btn.innerHTML =
          '<span class="hc-suggestion-pin">' +
            '<svg width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 0C2.69 0 0 2.69 0 6c0 4.5 6 10 6 10s6-5.5 6-10c0-3.31-2.69-6-6-6zm0 8.5A2.5 2.5 0 1 1 6 3.5a2.5 2.5 0 0 1 0 5z" fill="#a7a7a7"/></svg>' +
          '</span>' +
          '<span class="hc-suggestion-text">' +
            '<span class="hc-suggestion-name">' + city + '</span>' +
            '<span class="hc-suggestion-sub">' + sub + '</span>' +
          '</span>';
        btn.addEventListener('click', function() {
          if (prediction) {
            geocodeAndFetchWeatherForEdit(prediction, city);
          } else {
            fetchCityWeatherForEdit(city);
          }
        });
        editSuggestionsEl.appendChild(btn);
      });
    }

    if (editSearchInput) {
      editSearchInput.addEventListener('input', function() {
        clearTimeout(editDebounceTimer);
        var q = editSearchInput.value.trim();
        if (!q) { if (editSuggestionsEl) editSuggestionsEl.innerHTML = ''; return; }
        editDebounceTimer = setTimeout(function() {
          if (gmapsReady) {
            google.maps.places.AutocompleteSuggestion.fetchAutocompleteSuggestions(
              { input: q }
            )
              .then(function(response) {
                renderEditSuggestions(response && response.suggestions ? response.suggestions : []);
              })
              .catch(function() { renderEditSuggestions([]); });
          } else {
            // Fallback: Nominatim (OpenStreetMap)
            fetch('https://nominatim.openstreetmap.org/search?q=' + encodeURIComponent(q) + '&format=json&limit=5&addressdetails=1', { headers: { 'Accept-Language': 'en' } })
              .then(function(r) { return r.json(); })
              .then(renderEditSuggestions)
              .catch(function() {});
          }
        }, 350);
      });
      editSearchInput.addEventListener('keydown', function(e) {
        if (e.key === 'Enter') {
          clearTimeout(editDebounceTimer);
          var city = editSearchInput.value.trim();
          if (city) fetchCityWeatherForEdit(city);
        }
      });
    }

    if (intensitySlider) {
      intensitySlider.addEventListener('input', applyIntensityUI);
      intensitySlider.addEventListener('change', applyIntensityUI);
      // Don't call applyIntensityUI() at load — the step is hidden and getBoundingClientRect returns 0,0.
      // It's called via requestAnimationFrame in goToStep when navigating to step 2.
    }

    if (intensityCurve) {
      intensityCurve.addEventListener('click', function(e) {
        updateIntensityFromClientX(e.clientX);
      });

      intensityCurve.addEventListener('pointerdown', function(e) {
        updateIntensityFromClientX(e.clientX);
      });
    }

    if (intensityKnob) {
      intensityKnob.addEventListener('pointerdown', function(e) {
        e.preventDefault();
        var move = function(ev) {
          updateIntensityFromClientX(ev.clientX);
        };
        var up = function() {
          window.removeEventListener('pointermove', move);
          window.removeEventListener('pointerup', up);
        };
        window.addEventListener('pointermove', move);
        window.addEventListener('pointerup', up);
      });

      intensityKnob.addEventListener('keydown', function(e) {
        if (!intensitySlider) return;
        var current = parseInt(intensitySlider.value, 10);
        if (e.key === 'ArrowLeft') {
          intensitySlider.value = String(clamp(current - 5, 0, 100));
          applyIntensityUI();
        }
        if (e.key === 'ArrowRight') {
          intensitySlider.value = String(clamp(current + 5, 0, 100));
          applyIntensityUI();
        }
      });
    }

    if (intensityBackBtn) intensityBackBtn.addEventListener('click', function() { goToStep(1); window.scrollTo({ top: 0, behavior: 'smooth' }); });
    if (intensityProceedBtn) intensityProceedBtn.addEventListener('click', function() { goToStep(3); window.scrollTo({ top: 0, behavior: 'smooth' }); });

    wizard.querySelectorAll('.hc-pill[data-group="sweat"]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        wizard.querySelectorAll('.hc-pill[data-group="sweat"]').forEach(function(b) { b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
        state.sweat = btn.dataset.value;
        if (resultsProceedBtn) resultsProceedBtn.disabled = false;
      });
    });

    if (sweatBackBtn) sweatBackBtn.addEventListener('click', function() {
      state.sweat = null;
      wizard.querySelectorAll('.hc-pill[data-group="sweat"]').forEach(function(b) { b.classList.remove('is-selected'); });
      if (resultsProceedBtn) resultsProceedBtn.disabled = true;
      goToStep(2);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
    if (resultsProceedBtn) {
      resultsProceedBtn.addEventListener('click', function() {
        goToStep(4);
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    }

    if (recalcBtn) {
      recalcBtn.addEventListener('click', openEditModal);
    }

    function showPrompt(text) {
      results.hidden = true;
      results.classList.remove('is-visible');
      wizard.style.display = '';
      if (promptText) promptText.textContent  = text;
      prompt.style.display = '';
      hideRecCard();
    }

    function getDurationDisplay() {
      if (hoursInput && minutesInput) {
        var h = parseInt(hoursInput.value, 10) || 0;
        var m = parseInt(minutesInput.value, 10) || 0;
        if (h > 0 && m > 0) return h + 'h ' + m + 'm';
        if (h > 0) return h + 'h';
        return m + 'm';
      }
      var d = state.duration;
      if (d === 'lt1') return '< 1h';
      if (d === '1to2') return '1h 30m';
      if (d === '2to3') return '2h 30m';
      return '3h+';
    }

    function computeWaterRecommendation(sweat, duration, weather, intensity) {
      var baseRanges = {
        'mild|easy':         [300, 400],
        'mild|moderate':     [400, 500],
        'mild|hard':         [500, 600],
        'moderate|easy':     [400, 500],
        'moderate|moderate': [500, 600],
        'moderate|hard':     [600, 700],
        'heavy|easy':        [500, 600],
        'heavy|moderate':    [600, 700],
        'heavy|hard':        [700, 800]
      };
      var weatherMult  = { cold: 1.0, moderate: 1.15, hot: 1.35 };
      var durationMult = { lt1: 1.0, '1to2': 1.05, '2to3': 1.10, '3plus': 1.15 };
      var base = baseRanges[sweat + '|' + intensity];
      if (!base) return '';
      var mult = (weatherMult[weather] || 1.0) * (durationMult[duration] || 1.0);
      var min  = Math.round(base[0] * mult / 50) * 50;
      var max  = Math.round(base[1] * mult / 50) * 50;
      return min + '-' + max;
    }

    function computeSodiumRecommendation(sweat, duration, weather, intensity) {
      var baseRanges = {
        'mild':     [0.15, 0.40],
        'moderate': [0.40, 0.96],
        'heavy':    [0.96, 1.50]
      };
      var durationFactor  = { lt1: 0.75, '1to2': 1.00, '2to3': 1.15, '3plus': 1.30 };
      var weatherFactor   = { cold: 0.90, moderate: 1.00, hot: 1.25 };
      var intensityFactor = { easy: 1.00, moderate: 1.10, hard: 1.20 };
      var base = baseRanges[sweat];
      if (!base) return '';
      var mult = (durationFactor[duration] || 1.0) * (weatherFactor[weather] || 1.0) * (intensityFactor[intensity] || 1.0);
      var min = Math.round(base[0] * mult * 1000 / 10) * 10;
      var max = Math.round(base[1] * mult * 1000 / 10) * 10;
      return min + '-' + max;
    }

function mlRangeToLitres(mlText) {
      var parts = mlText.replace(/\s+/g, '').split('-');
      return parts.map(function(p) {
        var val = parseFloat(p) / 1000;
        return isNaN(val) ? p : (val % 1 === 0 ? val.toFixed(0) : parseFloat(val.toFixed(1)).toString());
      }).join(' - ');
    }

    function getGlassesLabel(waterText) {
      var parts = waterText.replace(/\s+/g, '').split('-');
      if (parts.length < 2) return '';
      var minG = Math.round(parseFloat(parts[0]) / 250);
      var maxG = Math.round(parseFloat(parts[1]) / 250);
      if (maxG <= minG) maxG = minG + 1;
      return minG + ' - ' + maxG + ' glasses/hr';
    }

    function getSachetLabel(sodiumText) {
      var normalized = sodiumText.replace(' to ', '-').replace(/\s+/g, '');
      var parts = normalized.split('-');
      if (parts.length < 2) return '';
      var sachetMin = Math.max(1, Math.round(parseFloat(parts[0]) / 500));
      var sachetMax = Math.max(1, Math.round(parseFloat(parts[1]) / 500));
      if (sachetMin === sachetMax) return sachetMin + ' sachet' + (sachetMin > 1 ? 's' : '');
      return sachetMin + ' - ' + sachetMax + ' sachets';
    }

    function renderHydrationStats(data) {
      var sodiumText = (data && data.sodiumRange || '').toString().trim();
      var waterText = (data && data.waterRecommendation || '').toString().trim();

      // Re-query by ID each render to avoid stale references after DOM updates.
      var sodiumEl = document.getElementById('hc-sodium-' + sid) || els.sodium;
      var sodiumBadgeEl = document.getElementById('hc-sodium-badge-' + sid) || els.sodiumBadge;
      var waterEl = document.getElementById('hc-water-' + sid) || els.water;

      if (sodiumEl) sodiumEl.textContent = sodiumText || '—';
      if (sodiumBadgeEl) {
        if (sodiumText) sodiumBadgeEl.classList.remove('is-hidden');
        else sodiumBadgeEl.classList.add('is-hidden');
      }
      if (waterEl) waterEl.textContent = waterText ? mlRangeToLitres(waterText) : '—';

      var waterSubEl = document.getElementById('hc-water-sub-' + sid);
      var sodiumSubEl = document.getElementById('hc-sodium-sub-' + sid);
      if (waterSubEl && waterText) {
        var glassesLabel = getGlassesLabel(waterText);
        waterSubEl.textContent = glassesLabel ? '~ Equals to ' + glassesLabel : '';
      }
      if (sodiumSubEl && sodiumText) {
        var sachetLabel = getSachetLabel(sodiumText);
        sodiumSubEl.textContent = sachetLabel ? '~ Equals to ' + sachetLabel : '';
      }
    }

    function calculate() {
      var sweat     = state.sweat;
      var duration  = state.duration;
      var weather   = state.weather;
      var intensity = state.intensity;

      if (!sweat || !duration || !weather || !intensity) {
        showPrompt('Complete all steps to view your hydration plan.');
        return;
      }

      var key  = sweat + '|' + duration + '|' + weather + '|' + intensity;
      var data = HYDRATION_DATA[key];

      if (!data) {
        showPrompt('Recommendations for this combination are coming soon.');
        return;
      }

      data = Object.assign({}, DURATION_GUIDANCE[sweat + '|' + intensity], data, {
        waterRecommendation: computeWaterRecommendation(sweat, duration, weather, intensity),
        sodiumRange: computeSodiumRecommendation(sweat, duration, weather, intensity)
      });

      // Display values exactly as provided in HYDRATION_DATA (no calculation)
      renderHydrationStats(data);

      // Activity cards
      var noteText = data.why || data.note || '';
      var whyText  = data.why || '';
      if (els.before) els.before.textContent = data.before || '';
      if (els.during) els.during.textContent = data.during || '';
      if (els.after)  els.after.textContent  = data.after || '';
      var waterLitres = data.waterRecommendation ? mlRangeToLitres(data.waterRecommendation.toString().trim()) : '';
      var sweatNoteText = waterLitres ? 'You might sweat out about ' + waterLitres + ' Litres, here is exactly how to replace it.' : noteText;
      if (els.note)   els.note.textContent   = sweatNoteText;

      // Activity detail notes (shown in tooltip on ? hover — only when a real "why" exists)
      if (els.beforeNote) els.beforeNote.textContent = whyText;
      if (els.duringNote) els.duringNote.textContent = whyText;
      if (els.afterNote)  els.afterNote.textContent  = whyText;
      var whyVisible = whyText ? '' : 'none';
      if (els.beforeWhyWrap) els.beforeWhyWrap.style.display = whyVisible;
      if (els.duringWhyWrap) els.duringWhyWrap.style.display = whyVisible;
      if (els.afterWhyWrap)  els.afterWhyWrap.style.display  = whyVisible;
      if (els.total)      els.total.textContent      = data.total || '';

      // Summary bar
      var durationLabel = getDurationDisplay();
      var intensityLabel = intensity.charAt(0).toUpperCase() + intensity.slice(1);
      var sweatLabel = sweat === 'mild' ? 'Very Little' : (sweat === 'moderate' ? 'Average' : 'Heavy');
      var locationLabel = state.city || (weather === 'cold' ? 'Cold' : (weather === 'moderate' ? 'Mild' : 'Hot'));

      // Sweat description modal content
      var sweatTitles = {
        mild: 'Mild Sweater',
        moderate: 'Moderate Sweater',
        heavy: 'Heavy Sweater'
      };
      var sweatDescriptions = {
        mild: 'You lose less sodium than most runners. Heat and intensity can still push you into deficit in case of longer duration runs, so do not skip electrolytes on hot days.',
        moderate: 'Most runners fall here. You lose a meaningful amount of sodium every hour. A consistent approach before, during and after keeps you running well.',
        heavy: 'You lose significantly more sodium than average. Those white salt marks on your kit after a run are proof. Front loading and staying consistent throughout is non-negotiable.'
      };
      var sweatTitleEl = document.getElementById('hc-sweat-title-' + sid);
      var sweatDescEl = document.getElementById('hc-sweat-desc-' + sid);
      if (sweatTitleEl) sweatTitleEl.textContent = sweatTitles[sweat] || '';
      if (sweatDescEl) sweatDescEl.textContent = sweatDescriptions[sweat] || '';

      if (els.sumDuration)  els.sumDuration.textContent  = durationLabel;
      if (els.sumIntensity) els.sumIntensity.textContent = intensityLabel;
      if (els.sumSweat)     els.sumSweat.textContent     = sweatLabel;
      if (els.sumLocation)  els.sumLocation.textContent  = locationLabel;

      // Rec card header
      if (els.recHeaderTitle) {
        els.recHeaderTitle.textContent = (state.name ? state.name + "'s" : 'Your') + ' personalised hydration Pack';
      }
      var baseQty = parseTotal(data.total);
      if (els.recHeaderSub) {
        var subtitle = getPackSubtitle(data.packRecommendation);
        els.recHeaderSub.textContent = subtitle;
      }

      // Update shareable URL
      var url = new URL(window.location.href);
      url.searchParams.set('sweat',     sweat);
      url.searchParams.set('duration',  duration);
      url.searchParams.set('weather',   weather);
      url.searchParams.set('intensity', intensity);
      if (state.city)     url.searchParams.set('city', state.city);
      else                url.searchParams.delete('city');
      if (state.temp != null)     url.searchParams.set('temp', state.temp);
      else                        url.searchParams.delete('temp');
      if (state.humidity != null) url.searchParams.set('humidity', state.humidity);
      else                        url.searchParams.delete('humidity');
      if (state.name)  url.searchParams.set('name', state.name);
      else             url.searchParams.delete('name');
      window.history.replaceState({}, '', url.toString());

      if (summaryEl) {
        summaryEl.textContent = [durationLabel, locationLabel, intensityLabel, sweatLabel].join(' · ');
      }

      prompt.style.display = 'none';
      wizard.style.display = 'none';
      results.hidden = false;
      requestAnimationFrame(function() {
        renderHydrationStats(data);
        results.classList.add('is-visible');
      });
      setTimeout(function() {
        renderHydrationStats(data);
      }, 0);

      // Product card — qty is in packs of 10, so ceil(sachets / 10)
      if (baseQty) {
        showRecCard(Math.max(1, Math.ceil(baseQty / 10)));
      } else {
        hideRecCard();
      }
    }

    // ── Download Results ──────────────────────────────────────────────────────
    function downloadResults() {
      var btn     = document.getElementById('hc-download-' + sid);
      var btnText = btn && btn.querySelector('.hc-download-btn-text');
      if (btn) btn.disabled = true;
      if (btnText) btnText.textContent = 'Generating…';

      var greeting  = els.greeting    ? els.greeting.textContent.trim()    : 'Hey there,';
      var userName  = greeting.replace(/^Hey\s+/i, '').replace(/,$/, '').trim() || 'there';
      var water     = els.water       ? els.water.textContent.trim()       : '—';
      var sodium    = els.sodium      ? els.sodium.textContent.trim()      : '—';
      var beforeTxt = els.before      ? els.before.textContent.trim()      : '½ sachet in 250 ml water';
      var duringTxt = (els.during && els.during.textContent.trim() && els.during.textContent.trim() !== '—')
                      ? els.during.textContent.trim()
                      : ((DURATION_GUIDANCE[(state.sweat || '') + '|' + (state.intensity || '')] || {}).during || '');
      var afterTxt  = els.after       ? els.after.textContent.trim()       : '1 sachet in 500 ml water';
      var duration  = els.sumDuration  ? els.sumDuration.textContent.trim()  : '—';
      var intensity = els.sumIntensity ? els.sumIntensity.textContent.trim() : '—';
      var sweat     = els.sumSweat     ? els.sumSweat.textContent.trim()     : '—';
      var cityName  = state.city || (els.sumLocation ? els.sumLocation.textContent.trim() : '');
      var tempStr   = state.temp     ? Math.round(state.temp) + '°C'  : '';
      var humStr    = state.humidity ? Math.round(state.humidity) + '% humidity' : '';

      var d = btn ? btn.dataset : {};
      var sachetGreenUrl = d.sachetGreenUrl || '';
      var sachetRedUrl   = d.sachetRedUrl   || '';

      function loadImg(url) {
        return new Promise(function (resolve) {
          if (!url) { resolve(null); return; }
          var img = new Image();
          img.crossOrigin = 'anonymous';
          img.onload  = function () { resolve(img); };
          img.onerror = function () { resolve(null); };
          img.src = url;
        });
      }

      var urlMap = [
        sachetGreenUrl,
        sachetRedUrl,
        d.icClockUrl         || '',
        d.icBarsUrl          || '',
        d.icDropUrl          || '',
        d.icHeroCircleUrl    || '',
        d.icBeforeUrl        || '',
        '',
        d.icNumCircleUrl     || '',
        d.icRunnerUrl        || '',
        '',
        '',
        d.icFlagUrl          || '',
        '',
        '',
        d.icPinUrl           || '',
        d.icThermoUrl        || '',
        d.icHumidUrl         || '',
        d.sachetTubeGreenUrl  || '',
        d.sachetTubePinkUrl   || '',
        d.bgVectorUrl         || '',
        wizard.dataset.logoUrl || '',
        d.icWaterFullUrl      || '',
        d.icSodiumFullUrl     || ''
      ];

      var fontP = document.fonts.load('bold 700 36px "Barlow Condensed"').catch(function () { return []; });
      Promise.all(urlMap.map(loadImg).concat([fontP])).then(function (results) {
        var imgs = results.slice(0, urlMap.length);
        var sachetGreenImg = imgs[0];
        var sachetRedImg   = imgs[1];
        var ic = {
          clock:        imgs[2],
          bars:         imgs[3],
          drop:         imgs[4],
          heroCircle:   imgs[5],
          before:       imgs[6],
          numCircle:    imgs[8],
          runner:       imgs[9],
          flag:         imgs[12],
          waterGlass:   null,
          pin:          imgs[15],
          thermo:       imgs[16],
          humid:        imgs[17],
          tubeGreen:    imgs[18],
          tubePink:     imgs[19],
          bgVector:     imgs[20],
          logo:         imgs[21],
          waterFull:    imgs[22],
          sodiumFull:   imgs[23]
        };
        render(sachetGreenImg, sachetRedImg, ic);
      });

      function render(sachetGreenImg, sachetRedImg, ic) {
        setTimeout(function () {
          try {
            var W = 800, H = 1000;
            var SANS = "'Poppins', Arial, sans-serif";
            var COND = "'Barlow Condensed', 'Arial Narrow', Arial, sans-serif";

            var DPR = 3;
            var cv = document.createElement('canvas');
            cv.width = W * DPR; cv.height = H * DPR;
            var ctx = cv.getContext('2d');
            ctx.imageSmoothingEnabled = true;
            ctx.imageSmoothingQuality = 'high';
            ctx.scale(DPR, DPR);

            function rr(x, y, w, h, r) {
              ctx.beginPath();
              ctx.moveTo(x+r, y); ctx.lineTo(x+w-r, y); ctx.arcTo(x+w, y, x+w, y+r, r);
              ctx.lineTo(x+w, y+h-r); ctx.arcTo(x+w, y+h, x+w-r, y+h, r);
              ctx.lineTo(x+r, y+h); ctx.arcTo(x, y+h, x, y+h-r, r);
              ctx.lineTo(x, y+r); ctx.arcTo(x, y, x+r, y, r);
              ctx.closePath();
            }

            // White background
            ctx.fillStyle = '#ffffff';
            ctx.fillRect(0, 0, W, H);

            // Background vector (provides the warm hero texture) — draw flipped vertically
            if (ic.bgVector) {
              ctx.save();
              ctx.translate(0, H);
              ctx.scale(1, -1);
              ctx.drawImage(ic.bgVector, 0, 0, W, H);
              ctx.restore();
            } else {
              ctx.fillStyle = '#f0eedc';
              ctx.fillRect(0, 96, W, 195);
            }

            // ── HEADER (y=0 to y=96) ─────────────────────────────────────

            // ascend logo
            if (ic.logo) {
              var logoH = 52, logoW = Math.round(ic.logo.naturalWidth * (logoH / ic.logo.naturalHeight));
              ctx.drawImage(ic.logo, 22, 48 - logoH / 2, logoW, logoH);
            } else {
              ctx.fillStyle = '#231f20';
              ctx.font = 'bold 20px ' + SANS;
              ctx.textAlign = 'left';
              ctx.textBaseline = 'alphabetic';
              ctx.fillText('ascend', 49, 68);
            }

            // "HYDRATION PLAN" — right-aligned near right edge
            ctx.fillStyle = '#231f20';
            ctx.font = 'bold 13px ' + SANS;
            ctx.textAlign = 'right';
            ctx.textBaseline = 'top';
            ctx.fillText('H Y D R A T I O N   P L A N', 775, 44);

            // Decorative red line under HYDRATION PLAN — right-aligned to match text
            ctx.strokeStyle = '#b22222';
            ctx.lineWidth = 1.5;
            ctx.beginPath(); ctx.moveTo(617, 65); ctx.lineTo(775, 65); ctx.stroke();

            // Header separator line (imgVector9)
            ctx.strokeStyle = '#e0e0e0';
            ctx.lineWidth = 1;
            ctx.beginPath(); ctx.moveTo(22, 96); ctx.lineTo(778, 96); ctx.stroke();

            // ── HERO (y=96 to y=290.7) ────────────────────────────────────

            // Hero decorative circle (imgGroup3)
            // inset-[13.1%_7.59%_75.42%_78.67%] → x=629.4, y=131, w=109.9, h=114.8
            if (ic.heroCircle) {
              ctx.drawImage(ic.heroCircle, 629, 131, 110, 115);
            }

            // "Hey [name],"  inset-[12.01%_69.71%_83.29%_6.41%] → x=51.3, y=120.1
            ctx.fillStyle = '#231f20';
            ctx.font = '500 33px ' + SANS;
            ctx.textAlign = 'left';
            ctx.textBaseline = 'top';
            ctx.fillText('Hey ' + userName + ',', 51, 120);

            // Subtitle  inset-[17.03%_59.88%_80.67%_6.49%] → x=51.9, y=170.3
            ctx.fillStyle = '#58595b';
            ctx.font = '500 16px ' + SANS;
            ctx.fillText('Your personalised hydration plan', 52, 170);

            // Location meta row — dynamic width pill
            if (cityName || tempStr || humStr) {
              var CAP_Y = 213, CAP_H = 39, CAP_R = 20, CAP_PAD = 20;
              var PIN_W = 12, PIN_H = 15;
              var thrH = 16, thrW = ic.thermo ? Math.round(ic.thermo.naturalWidth / ic.thermo.naturalHeight * thrH) : 0;
              var dropH = 14, dropW = ic.humid ? Math.round(ic.humid.naturalWidth / ic.humid.naturalHeight * dropH) : 0;

              ctx.font = '400 14px ' + SANS;

              // Pre-measure content width for dynamic capsule
              var contentW = 0;
              if (cityName) {
                if (ic.pin) contentW += PIN_W + 6;
                contentW += ctx.measureText(cityName).width;
                if (tempStr || humStr) contentW += 14;
              }
              if (tempStr) {
                contentW += thrW + 6 + ctx.measureText(tempStr).width;
                if (humStr) contentW += 14;
              }
              if (humStr) {
                contentW += dropW + 6 + ctx.measureText(humStr).width;
              }

              var CAP_W = Math.round(contentW + CAP_PAD * 2);
              var CAP_X = 50;
              var capCY = CAP_Y + CAP_H / 2;

              rr(CAP_X, CAP_Y, CAP_W, CAP_H, CAP_R);
              ctx.strokeStyle = '#c8c8c8'; ctx.lineWidth = 1.5; ctx.stroke();

              ctx.textBaseline = 'middle';
              ctx.fillStyle = '#231f20';
              var cur = CAP_X + CAP_PAD;

              if (cityName) {
                if (ic.pin) {
                  ctx.drawImage(ic.pin, cur, capCY - PIN_H / 2, PIN_W, PIN_H);
                  cur += PIN_W + 6;
                }
                ctx.fillText(cityName, cur, capCY);
                cur += ctx.measureText(cityName).width;

                if (tempStr || humStr) {
                  cur += 7;
                  ctx.strokeStyle = '#d0d0d0'; ctx.lineWidth = 1;
                  ctx.beginPath(); ctx.moveTo(cur, CAP_Y + 9); ctx.lineTo(cur, CAP_Y + CAP_H - 9); ctx.stroke();
                  cur += 7;
                }
              }

              if (tempStr) {
                if (ic.thermo) {
                  ctx.drawImage(ic.thermo, cur, capCY - thrH / 2, thrW, thrH);
                  cur += thrW + 6;
                }
                ctx.fillStyle = '#231f20';
                ctx.fillText(tempStr, cur, capCY);
                cur += ctx.measureText(tempStr).width;

                if (humStr) {
                  cur += 7;
                  ctx.strokeStyle = '#d0d0d0'; ctx.lineWidth = 1;
                  ctx.beginPath(); ctx.moveTo(cur, CAP_Y + 9); ctx.lineTo(cur, CAP_Y + CAP_H - 9); ctx.stroke();
                  cur += 7;
                }
              }

              if (humStr) {
                if (ic.humid) {
                  ctx.drawImage(ic.humid, cur, capCY - dropH / 2, dropW, dropH);
                  cur += dropW + 6;
                }
                ctx.fillStyle = '#231f20';
                ctx.fillText(humStr, cur, capCY);
              }

              ctx.textBaseline = 'top';
            }

            // ── STATS CARD (y=290.7 to y=400.9) ──────────────────────────
            // inset-[29.07%_4.25%_59.91%_6.25%] → x=50, y=290.7, w=716, h=110.2
            rr(50, 290.7, 716, 110.2, 10);
            ctx.fillStyle = '#ffffff'; ctx.fill();
            ctx.strokeStyle = '#e0e0e0'; ctx.lineWidth = 1; ctx.stroke();

            // Vertical dividers
            // inset-[30.74%_64.04%_61.06%_35.96%] → x=287.7, y=307.4, h=82
            // inset-[30.74%_33.5%_61.06%_66.5%]   → x=532, y=307.4, h=82
            ctx.strokeStyle = '#e0e0e0'; ctx.lineWidth = 1;
            [287.7, 532].forEach(function (xd) {
              ctx.beginPath(); ctx.moveTo(xd, 307); ctx.lineTo(xd, 389); ctx.stroke();
            });

            // Duration column
            // Label: inset-[30.64%_83.83%_67.46%_8.92%] → x=71.4, y=306.4
            ctx.fillStyle = '#6d6e70'; ctx.font = '400 13px ' + SANS;
            ctx.textAlign = 'left'; ctx.textBaseline = 'top';
            ctx.fillText('Duration', 71, 306);
            // Value: inset-[34.44%_88.08%_61.56%_8.92%] → x=71.4, y=344.4
            ctx.fillStyle = '#231f20'; ctx.font = '600 33px ' + COND;
            ctx.fillText(duration, 71, 344);
            // Clock icon: inset-[30.21%_68.36%_66.84%_27.95%] → x=223.6, y=302.1, w=29.5, h=29.5
            if (ic.clock) { ctx.drawImage(ic.clock, 224, 302, 30, 30); }

            // Intensity column
            // Label: inset-[30.64%_52.6%_67.46%_40.27%] → x=322.2, y=306.4
            ctx.fillStyle = '#6d6e70'; ctx.font = '400 13px ' + SANS;
            ctx.fillText('Intensity', 322, 306);
            // Value: inset-[34.44%_52.85%_61.56%_40.27%] → x=322.2, y=344.4
            ctx.fillStyle = '#231f20'; ctx.font = '600 33px ' + COND;
            ctx.fillText(intensity, 322, 344);
            // Bars icon: inset-[30.29%_37.82%_67.27%_58.62%] → x=469, y=302.9, w=28.5, h=24.4
            if (ic.bars) { ctx.drawImage(ic.bars, 469, 303, 28, 24); }

            // Sweat column
            // Label: inset-[30.64%_23.94%_67.46%_70.81%] → x=566.5, y=306.4
            ctx.fillStyle = '#6d6e70'; ctx.font = '400 13px ' + SANS;
            ctx.fillText('Sweat', 567, 306);
            // Value: inset-[34.44%_20.19%_61.56%_70.81%] → x=566.5, y=344.4
            ctx.fillStyle = '#231f20'; ctx.font = '600 33px ' + COND;
            ctx.fillText(sweat, 567, 344);
            // Drop icon: inset-[30.34%_6.93%_66.91%_89.74%] → x=717.9, y=303.4, w=26.6, h=27.5
            if (ic.drop) { ctx.drawImage(ic.drop, 718, 303, 27, 28); }

            // ── NEEDS SECTION LABEL ───────────────────────────────────────
            // inset-[44.27%_62.38%_53.73%_6.25%] → x=50, y=442.7
            ctx.fillStyle = '#808184'; ctx.font = '500 14px ' + SANS;
            ctx.textAlign = 'left'; ctx.textBaseline = 'top';
            ctx.fillText('WHAT YOUR BODY NEEDS PER HOUR', 50, 443);

            // ── NEEDS CARD (y=472.4 to y=582.7) ──────────────────────────
            // inset-[47.24%_4.25%_41.73%_6.25%] → x=50, y=472.4, w=716, h=110.3
            rr(50, 472, 716, 111, 10);
            ctx.fillStyle = '#ffffff'; ctx.fill();
            ctx.strokeStyle = '#e0e0e0'; ctx.lineWidth = 1; ctx.stroke();

            // Center divider  inset-[48.66%_49%_43.14%_51%] → x=408, y=486.6, h=82
            ctx.strokeStyle = '#e0e0e0';
            ctx.beginPath(); ctx.moveTo(408, 487); ctx.lineTo(408, 569); ctx.stroke();

            // LEFT column: WATER/HOUR — full SVG icon (circle + water glass)
            var icSvgSize = 42;
            if (ic.waterFull) {
              ctx.drawImage(ic.waterFull, 72, 505, icSvgSize, icSvgSize);
            }
            // WATER / HOUR label
            ctx.fillStyle = '#6d6e70'; ctx.font = 'bold 9.8px ' + SANS;
            ctx.textBaseline = 'top';
            ctx.fillText('WATER / HOUR', 132, 493);
            // Water value
            ctx.fillStyle = '#231f20'; ctx.font = 'bold 36px ' + COND;
            ctx.textBaseline = 'alphabetic';
            ctx.letterSpacing = '0.773px';
            ctx.fillText(water, 132, 540);
            var waterW = ctx.measureText(water).width;
            ctx.letterSpacing = '0px';
            ctx.fillStyle = '#6d6e70'; ctx.font = '400 10.6px ' + SANS;
            ctx.fillText('L / hr', 132 + waterW + 8, 540);
            ctx.textBaseline = 'top';

            // RIGHT column: SODIUM/HOUR — full SVG icon (circle + sodium)
            if (ic.sodiumFull) {
              ctx.drawImage(ic.sodiumFull, 438, 505, icSvgSize, icSvgSize);
            }
            // SODIUM / HOUR label
            ctx.fillStyle = '#6d6e70'; ctx.font = 'bold 9.8px ' + SANS;
            ctx.fillText('SODIUM / HOUR', 498, 493);
            // Sodium value
            ctx.fillStyle = '#231f20'; ctx.font = 'bold 36px ' + COND;
            ctx.textBaseline = 'alphabetic';
            ctx.fillText(sodium, 498, 540);
            var sodiumW = ctx.measureText(sodium).width;
            ctx.fillStyle = '#6d6e70'; ctx.font = '400 10.6px ' + SANS;
            ctx.fillText('mg / hr', 498 + sodiumW + 8, 540);
            ctx.textBaseline = 'top';

            // ── TIMELINE LABEL ────────────────────────────────────────────
            // inset-[63.22%_72.25%_34.78%_6.25%] → x=50, y=632.2
            ctx.fillStyle = '#808184'; ctx.font = '500 14px ' + SANS;
            ctx.textBaseline = 'top';
            ctx.fillText('YOUR ACTIVITY TIMELINE', 50, 632);

            // Dashed connector lines between numbered circles
            // First: inset-[70.11%_91.46%_24.3%_8.54%] → x=68.3, y=701.1, h=55.9
            // Second: inset-[78.21%_91.46%_16.21%_8.54%] → x=68.3, y=782.1, h=55.8
            ctx.save();
            ctx.strokeStyle = '#cccccc'; ctx.lineWidth = 1.5;
            ctx.setLineDash([4, 5]);
            ctx.beginPath(); ctx.moveTo(68, 701); ctx.lineTo(68, 757); ctx.stroke();
            ctx.beginPath(); ctx.moveTo(68, 782); ctx.lineTo(68, 838); ctx.stroke();
            ctx.restore();

            // ── BEFORE ROW ────────────────────────────────────────────────

            // Numbered circle 1  inset-[67.69%_89.94%_29.91%_7.06%] → x=56.5, y=676.9, w=24, h=24
            if (ic.numCircle) { ctx.drawImage(ic.numCircle, 56, 677, 24, 24); }
            ctx.fillStyle = '#231f20'; ctx.font = 'bold 14px ' + SANS;
            ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
            ctx.fillText('1', 68, 689);

            // Before icon (single SVG 32×32)
            if (ic.before) { ctx.drawImage(ic.before, 106, 672, 32, 32); }

            // "BEFORE"  inset-[66.03%_69.73%_30.57%_20.39%] → x=163.1, y=660.3
            ctx.fillStyle = '#231f20'; ctx.font = 'bold 28px ' + COND;
            ctx.textAlign = 'left'; ctx.textBaseline = 'top';
            ctx.fillText('BEFORE', 163, 660);
            // Sub  inset-[69.46%_58.91%_28.64%_20.22%] → x=161.8, y=694.6
            ctx.fillStyle = '#58595b'; ctx.font = '500 13px ' + SANS;
            ctx.fillText('30-45 min before activity', 162, 695);

            // BEFORE sachet tube (green)  inset-[64.9%_4.25%_27.94%_70.85%] → x=567.8, y=649, w=199.2, h=71.6
            if (ic.tubeGreen) {
              ctx.save();
              ctx.translate(0, 649 + 71.6);
              ctx.scale(1, -1);
              ctx.drawImage(ic.tubeGreen, 568, 0, 199, 71.6);
              ctx.restore();
            }
            // Green sachet photo — Figma: 27.96px above tube, 17.29px below, 8.56px left of tube
            if (sachetGreenImg) {
              ctx.save();
              var sH = 106;
              var sW = sachetGreenImg.naturalWidth && sachetGreenImg.naturalHeight
                ? Math.round(sachetGreenImg.naturalWidth / sachetGreenImg.naturalHeight * sH)
                : 98;
              ctx.translate(608, 679);
              ctx.rotate(-6.62 * Math.PI / 180);
              ctx.drawImage(sachetGreenImg, -sW / 2, -sH / 2, sW, sH);
              ctx.restore();
            }
            // BEFORE text  inset-[66.73%_7.89%_29.77%_79.61%] → x=636.9, y=667.3
            ctx.fillStyle = '#231f20'; ctx.font = 'bold 15px ' + COND;
            ctx.textAlign = 'left'; ctx.textBaseline = 'top';
            ctx.fillText(beforeTxt.split(' in ')[0] + ' in', 637, 667);
            ctx.fillText(beforeTxt.split(' in ')[1] || '', 637, 688);

            // ── DURING ROW ────────────────────────────────────────────────

            // Numbered circle 2  inset-[75.72%_89.94%_21.88%_7.06%] → x=56.5, y=757.2, w=24, h=24
            if (ic.numCircle) { ctx.drawImage(ic.numCircle, 56, 757, 24, 24); }
            ctx.fillStyle = '#231f20'; ctx.font = 'bold 14px ' + SANS;
            ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
            ctx.fillText('2', 68, 769);

            // Runner (single SVG 29×38)
            if (ic.runner) { ctx.drawImage(ic.runner, 107, 751, 29, 38); }

            // "DURING"  inset-[74.06%_69.98%_22.54%_20.39%] → x=163.1, y=740.6
            ctx.fillStyle = '#231f20'; ctx.font = 'bold 28px ' + COND;
            ctx.textAlign = 'left'; ctx.textBaseline = 'top';
            ctx.fillText('DURING', 163, 741);
            // Sub  inset-[77.49%_63.28%_20.61%_20.22%] → x=161.8, y=774.9
            ctx.fillStyle = '#58595b'; ctx.font = '500 13px ' + SANS;
            ctx.fillText('Every 15-20 minutes', 162, 775);

            // DURING sachet tube (pink)  inset-[72.94%_4.25%_19.91%_70.85%] → x=567.8, y=729.4, w=199.2, h=71.5
            if (ic.tubePink) {
              ctx.save();
              ctx.translate(0, 729 + 72);
              ctx.scale(1, -1);
              ctx.drawImage(ic.tubePink, 568, 0, 199, 72);
              ctx.restore();
            }
            // Pink sachet photo — same Figma offsets applied to DURING tube (y=729, h=72)
            if (sachetRedImg) {
              ctx.save();
              var sH = 106;
              var sW = sachetRedImg.naturalWidth && sachetRedImg.naturalHeight
                ? Math.round(sachetRedImg.naturalWidth / sachetRedImg.naturalHeight * sH)
                : 98;
              ctx.translate(608, 760);
              ctx.rotate(14.26 * Math.PI / 180);
              ctx.drawImage(sachetRedImg, -sW / 2, -sH / 2, sW, sH);
              ctx.restore();
            }
            // DURING text  (mirrors BEFORE/AFTER positions shifted by 80px)
            ctx.fillStyle = '#231f20'; ctx.font = 'bold 15px ' + COND;
            ctx.textAlign = 'left'; ctx.textBaseline = 'top';
            ctx.fillText(duringTxt.replace(/ per hour.*/i, ''), 637, 748);
            ctx.fillText(/ per hour/i.test(duringTxt) ? 'per hour' : '', 637, 769);

            // ── AFTER ROW ─────────────────────────────────────────────────

            // Numbered circle 3  inset-[83.76%_89.94%_13.84%_7.06%] → x=56.5, y=837.6, w=24, h=24
            if (ic.numCircle) { ctx.drawImage(ic.numCircle, 56, 838, 24, 24); }
            ctx.fillStyle = '#231f20'; ctx.font = 'bold 14px ' + SANS;
            ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
            ctx.fillText('3', 68, 850);

            // Flag  inset-[83.47%_83.26%_13.97%_13.63%] → x=109, y=834.7, w=24.9, h=25.6
            if (ic.flag) { ctx.drawImage(ic.flag, 109, 835, 25, 26); }

            // "AFTER"  inset-[82.09%_71.23%_14.51%_20.39%] → x=163.1, y=820.9
            ctx.fillStyle = '#231f20'; ctx.font = 'bold 28px ' + COND;
            ctx.textAlign = 'left'; ctx.textBaseline = 'top';
            ctx.fillText('AFTER', 163, 821);
            // Sub  inset-[85.53%_59.03%_12.57%_20.22%] → x=161.8, y=855.3
            ctx.fillStyle = '#58595b'; ctx.font = '500 13px ' + SANS;
            ctx.fillText('Within 30 min of finishing', 162, 855);

            // AFTER sachet tube (green)  inset-[80.97%_4.25%_11.88%_70.85%] → x=567.8, y=809.7, w=199.2, h=71.5
            if (ic.tubeGreen) {
              ctx.save();
              ctx.translate(0, 810 + 72);
              ctx.scale(1, -1);
              ctx.drawImage(ic.tubeGreen, 568, 0, 199, 72);
              ctx.restore();
            }
            // AFTER green sachet photo — same Figma offsets applied to AFTER tube (y=810, h=72)
            if (sachetGreenImg) {
              ctx.save();
              var sH = 106;
              var sW = sachetGreenImg.naturalWidth && sachetGreenImg.naturalHeight
                ? Math.round(sachetGreenImg.naturalWidth / sachetGreenImg.naturalHeight * sH)
                : 98;
              ctx.translate(608, 841);
              ctx.rotate(-6.62 * Math.PI / 180);
              ctx.drawImage(sachetGreenImg, -sW / 2, -sH / 2, sW, sH);
              ctx.restore();
            }
            // AFTER text  inset-[82.8%_7.72%_13.7%_79.53%] → x=636.2, y=828
            ctx.fillStyle = '#231f20'; ctx.font = 'bold 15px ' + COND;
            ctx.textAlign = 'left'; ctx.textBaseline = 'top';
            ctx.fillText(afterTxt.split(' in ')[0] + ' in', 636, 828);
            ctx.fillText(afterTxt.split(' in ')[1] || '', 636, 849);

            // ── FOOTER ───────────────────────────────────────────────────
            // Separator  inset-[92.62%_4.25%_2.38%_6.25%] → x=50, y=926.2, to x=750
            ctx.strokeStyle = '#e0e0e0'; ctx.lineWidth = 1;
            ctx.beginPath(); ctx.moveTo(50, 926); ctx.lineTo(750, 926); ctx.stroke();

            // "ascendliv.com"  inset-[94%_76.28%_3.9%_8.97%] → x=71.8, y=940
            ctx.fillStyle = '#231f20'; ctx.font = 'bold 15px ' + SANS;
            ctx.textAlign = 'left'; ctx.textBaseline = 'top';
            ctx.fillText('ascendliv.com', 72, 940);

            // "ZERO SUGAR ELECTROLYTES"  inset-[94.08%_6.88%_3.92%_68.25%] → x=546, y=940.8
            ctx.fillStyle = '#939598'; ctx.font = 'bold 14px ' + SANS;
            ctx.fillText('ZERO SUGAR ELECTROLYTES', 546, 941);

            // ── EXPORT ───────────────────────────────────────────────────
            cv.toBlob(function (blob) {
              var url = URL.createObjectURL(blob);
              var a = document.createElement('a');
              a.href = url; a.download = 'ascendliv-hydration-plan.png';
              document.body.appendChild(a); a.click(); document.body.removeChild(a);
              setTimeout(function () { URL.revokeObjectURL(url); cv.width = 0; cv.height = 0; }, 5000);
              if (btn) btn.disabled = false;
              if (btnText) btnText.textContent = 'Download result';
            }, 'image/png');

          } catch (err) {
            console.error('HC download error:', err);
            if (btn) btn.disabled = false;
            if (btnText) btnText.textContent = 'Download result';
          }
        }, 60);
      }
    }

    var downloadBtn = document.getElementById('hc-download-' + sid);
    if (downloadBtn) {
      downloadBtn.addEventListener('click', downloadResults);
    }

    // Auto-load from URL params (for email links)
    var params = new URLSearchParams(window.location.search);
    var pre = {
      sweat:     params.get('sweat'),
      duration:  params.get('duration'),
      weather:   params.get('weather'),
      intensity: params.get('intensity'),
      city:      params.get('city'),
      temp:      params.get('temp')     !== null ? parseFloat(params.get('temp'))     : null,
      humidity:  params.get('humidity') !== null ? parseFloat(params.get('humidity')) : null,
      name:      params.get('name'),
    };
    if (pre.sweat && pre.duration && pre.weather && pre.intensity) {
      // Restore sweat pill
      var sweatBtn = wizard.querySelector('.hc-pill[data-group="sweat"][data-value="' + pre.sweat + '"]');
      if (sweatBtn) { sweatBtn.classList.add('is-selected'); state.sweat = pre.sweat; }

      // Restore duration counter from bucket
      state.duration = pre.duration;
      var preHours = 1, preMinutes = 0;
      if (pre.duration === 'lt1') { preHours = 0; preMinutes = 45; }
      else if (pre.duration === '1to2') { preHours = 1; preMinutes = 30; }
      else if (pre.duration === '2to3') { preHours = 2; preMinutes = 30; }
      else if (pre.duration === '3plus') { preHours = 3; preMinutes = 30; }
      if (hoursInput) { hoursInput.value = padTwo(preHours); syncScrollToInput('hours', preHours); }
      if (minutesInput) { minutesInput.value = padTwo(preMinutes); syncScrollToInput('minutes', preMinutes); }

      state.weather = pre.weather;
      state.intensity = pre.intensity;
      if (pre.city)            state.city     = pre.city;
      if (pre.temp != null)    state.temp     = pre.temp;
      if (pre.humidity != null) state.humidity = pre.humidity;
      if (pre.name)            state.name     = pre.name;

      if (intensitySlider) {
        if (pre.intensity === 'easy') intensitySlider.value = '0';
        else if (pre.intensity === 'moderate') intensitySlider.value = '50';
        else intensitySlider.value = '100';
        applyIntensityUI();
      }

      calculate();
      if (pre.name && els.greeting) {
        els.greeting.textContent = 'Hey ' + pre.name + ',';
      }
      goToStep(totalSteps);
      // goToStep(4) calls resetWeatherScreen() which nulls state.weather — restore it
      state.weather = pre.weather;
    } else {
      prompt.style.display = 'none';
      goToStep(1);
    }
  }

  function initAll() {
    document.querySelectorAll('[id^="hc-wizard-"]').forEach(function(el) {
      initCalculator(el.id.replace('hc-wizard-', ''));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
